import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {
  ModalController,
  AlertController,
  Platform,
  ToastController,
  LoadingController,
  NavParams,
  IonicSlides,
} from '@ionic/angular';
import * as moment from 'moment';
import {
  TeeTimeSlotDisplay,
  ClubTeeTimeSlots,
  TeeTimeBooking,
  TeeTimeBookingOptions,
  TeeTimeClubVoucher,
  PagedData,
  ServerInfo,
  BookingCount,
  Country,
  DiscountCompany,
  ClubData,
} from 'src/data/mygolf.data';
import { CourseInfo, ClubInfo, createCourseInfo, createClubInfo } from 'src/data/club-course';
import {
  createPlayerList,
  FriendRequest,
  FriendRequestList,
  PlayerHomeInfo,
  PlayerInfo,
  PlayerList,
} from '../../../../data/player-data';
import { CommonProvider } from '../../commonServices/common';
import { DateAndTimePage } from '../../modal-screens/date-and-time/date-and-time.page';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Observable, Subscription, of } from 'rxjs';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { EventObserver } from 'src/providers/event-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo,
} from 'src/providers/pushnotification-service/notification-handler-constructs';
import { NewContactPage } from '../../new-contact/new-contact.page';
import { ProfilePage } from '../../profile/profile.page';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { SessionInfo } from 'src/data/authentication-info';
import { RecentClubPage } from '../../performance/recent-club/recent-club.page';
import { SelectDatesPage } from '../../modal-screens/select-dates/select-dates.page';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { JsonService } from 'src/json-util';
import { CountryListPage } from '../../modal-screens/country-list/country-list.page';
import { ClubListPage } from '../../normalgame/club-list/club-list.page';
import { SearchTeeTimeComponent } from './search-tee-time/search-tee-time.component';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import Swiper from 'swiper';
@Component({
  selector: 'app-booking-home',
  templateUrl: './booking-home.page.html',
  styleUrls: ['./booking-home.page.scss'],
})
export class BookingHomePage implements OnInit {
  appAttribute: any;
  tabs: any;
  loader: any;
  today: any = moment().format('YYYY-MM-DD');
  maxDate: any = moment().add(3, 'y').format('YYYY-MM-DD');

  searchFriend: string = '';
  userType: string = 'player';
  startDate: string = moment().add(1, 'days').format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');
  bookings: string = 'mybookings';
  selectClubType: string = 'allClubs';
  fromTime: string = '07:00';
  toTime: string = '17:00';
  searchDistance: number = 50;
  courseType: string = 'club';
  friendScreenName: string = 'Friends';
  friends: string = 'friend';
  friendType: string = 'friend';
  errorMessage: string;
  histNextMonth: string;
  histPastDate: string;
  currentDate: string;
  histStartDate: string;
  histEndDate: string;
  activeDate: string;
  cancelPastDate: string;
  cancelNextMonth: string;
  activeDateSince: string;
  cancelStartDate: string;
  cancelEndDate: string;
  searchPlayer: string = '';
  captchaResponse: string = '';
  countryList: Array<Country>;
  filterCountry: Country;
  cancelCurrentPage: number;
  cancelTotalPages: number;
  cancelTotalItems: number;
  cancelPageSize: number;
  currentMaxBooking: number = 0;
  historyCurrentPage: number;
  historyTotalPages: number;
  historyTotalItems: number;
  historyPageSize: number;
  activeCurrentPage: number;
  activeTotalPages: number;
  activeTotalItems: number;
  activePageSize: number;
  filteredLocation: string = '';
  botsOut: boolean = true;
  refreshOnEnter: boolean = false;
  useHistorical: boolean = false;
  toggleActivePanel: boolean = true;
  togglePastPanel: boolean = false;
  toggleCancelPanel: boolean = false;
  toggleInvitedPanel: boolean = false;
  fromBookNow: boolean = false;
  toggleSlots: boolean = false;
  togglePastSlots: boolean = false;
  toggleCancelSlots: boolean = false;
  toggleInvitedSlots: boolean = false;
  refresherCancelr: boolean = false;
  refresherInvitedr: boolean = false;
  refresher: boolean = false;
  refresherInvited = false;
  refresherPast = false;
  historyMonthly: boolean = true;
  enableNearby: boolean = false;
  refresherCancel = false;
  cancelMonthly: boolean = true;
  refreshAttempted: boolean = false;
  sentExist: boolean = false;
  receiveExist: boolean = false;
  refreshPlayer: boolean = false;

  courseInfo: CourseInfo;
  clubInfo: ClubInfo & ClubData;
  playerList: PlayerList;
  requestFriends: FriendRequestList;
  listFriends: PlayerList;
  favClubs: Array<ClubInfo>;
  bookingByPlayerList: Array<TeeTimeBooking>;
  invitedBookingForPlayerList: Array<TeeTimeBooking>;
  pastBookingByPlayerList: Array<TeeTimeBooking>;
  activePlayerBookingList: PagedData<TeeTimeBooking>;
  historyPlayerBookingList: PagedData<TeeTimeBooking>;
  cancelledBookingByPlayerList: Array<TeeTimeBooking>;
  cancelPlayerBookingList: PagedData<TeeTimeBooking>;
  activeBookingForPlayerList: Array<TeeTimeBooking>;
  receivedList: Array<FriendRequest> = new Array<FriendRequest>();
  sentList: Array<FriendRequest> = new Array<FriendRequest>();
  friendRequests: Array<FriendRequest> = new Array<FriendRequest>();
  playerRequests: Array<FriendRequest> = new Array<FriendRequest>();
  playerHomeInfo$: Observable<PlayerHomeInfo>;
  player$: Observable<PlayerInfo>;
  navigationExtras: NavigationExtras = {};
  private session: SessionInfo;
  dataExtras: any;
  isClubSpecific: boolean = false;
  bookingOptions: TeeTimeBookingOptions;
  playerMaxBooking: BookingCount;
  selectedClub: any;
  noneToPayShort: string = 'None';
  partnerInfo: DiscountCompany;

  searchQuery: string = '';
  isFromTabPage: boolean = false;

  swiperMenuModules = [IonicSlides];
  @ViewChild('swiperTabContainer', { static: false }) swiperTabContainer: ElementRef;
  swiperMenu: any; //Swiper | undefined;
  constructor(
    private keyboard: Keyboard,
    private commonProvider: CommonProvider,
    private router: Router,
    private modalCtl: ModalController,
    private platform: Platform,
    private toastCtl: ToastController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private playerHomeService: PlayerHomeDataService,
    private serverInfoService: ServerInfoService,
    private flightService: ClubFlightService,
    private globalEventObserver: EventObserver,
    private route: ActivatedRoute,
    private playerService: PlayerService,
    private friendService: FriendService,
    private geo: GeolocationService,
    private location: Location,
    private mg2uUtil: mygolfUtils,
    private navParams: NavParams
  ) {
    this.dataExtras = this.router.getCurrentNavigation().extras.state;

    this.tabs = [
      { title: 'Schedule', icon: 'calendar' },
      { title: 'Speakers', icon: 'contacts' },
      { title: 'Map', icon: 'map' },
      { title: 'About', icon: 'information-circle' },
    ];

    this.requestFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      friendRequests: new Array<FriendRequest>(),
    };
    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>(),
    };
    this.globalEventObserver.getObservable().subscribe(data => {
      if (data.chanel == 'FriendListUpdate') {
        this._refreshValues(null, null);
      }
      if (data.chanel == 'FriendRequestUpdate') {
        this.friends = 'request';
        this._refreshValues(null, null);
      }
    });
    this.playerList = createPlayerList();
    let _fromCancel: any;
    if (this.dataExtras) {
      this.fromBookNow = this.dataExtras.fromBookNow;
      this.userType = this.dataExtras.userType;
      _fromCancel = this.dataExtras.cancelBooking;
      this.partnerInfo = this.dataExtras.partnerInfo;
      this.selectedClub = this.dataExtras.selectedClub;
    }
    this.selectedClub = this.mg2uUtil.getSelectedClub();
    this.isClubSpecific = this.mg2uUtil.getClubSpecific();

    if (_fromCancel) {
      this.setBookingType(2);
      this.togglePanel(1);
      this.refreshBookingHome(true);
    }

    if (!this.userType) this.userType = 'player';
    if (this.fromBookNow) this.bookings = 'mybookings';
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    }

    this.maxDate = moment(this.maxDate).add(3, 'y').format('YYYY-MM-DD');

    this.histNextMonth = moment().endOf('month').format('YYYY-MM-DD');
    this.histPastDate = moment().format('YYYY-MM-DD'); //moment().add(-1, 'month').format("YYYY-MM-DD");
    this.currentDate = moment().format('YYYY-MM-DD');
    this.histStartDate = moment().add(-7, 'days').format('YYYY-MM-DD');
    this.histEndDate = moment().add(7, 'days').format('YYYY-MM-DD');

    this.cancelNextMonth = moment().endOf('month').format('YYYY-MM-DD');
    this.cancelPastDate = moment().format('YYYY-MM-DD'); //moment().add(-1, 'month').format("YYYY-MM-DD");
    this.cancelStartDate = moment().add(-7, 'days').format('YYYY-MM-DD');
    this.cancelEndDate = moment().add(7, 'days').format('YYYY-MM-DD');
    this.activeMaxDate = moment().add(1, 'years').format('YYYY-MM-DD');
    this.activeDate = moment().endOf('month').format('YYYY-MM-DD');
    this.activePrevMonth = moment().startOf('month').format('YYYY-MM-DD');
    let _param = this.platform.getQueryParam('param');
    if (_param) {
      this.selectedClub = this.navParams.get('club');
    } else if (!_param && this.mg2uUtil.getClubMembership()) {
      this.selectedClub = this.mg2uUtil.getClubMembership().club;
    }
  }

  activeMaxDate: string;
  activePrevMonth: string;

  backButtonSubscription: Subscription;
  ngOnInit() {
    this.initSwiper();
    // this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(9999, async () => {
    //   const modal = await this.modalCtl.getTop();
    //   console.debug('set up back button ',modal)
    //   if (modal) {
    //     // If a modal is open, prevent default back button behavior
    //     return;
    //   }
    // });
    if (this.router.url === '/tabs/booking-home') {
      this.isFromTabPage = true;
    } else {
      this.isFromTabPage = false;
    }
    this.getAppAttribute();
    this.getCountry();
    if (this.userType === 'player') {
      if (this.bookings === 'mybookings') {
        // this.refreshActiveBooking();
        // this.refreshInvitedBooking();
        this.newRefreshActiveBooking();
      }
      this.refreshFavouriteClubs();

      setTimeout(() => {
        this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
          if (this.countryList) {
            this.countryList
              .filter((c: Country) => {
                return player.addressInfo && c.id === player.addressInfo.countryId;
              })
              .map(c => {
                this.filterCountry = c;
              });
          }
          // this.filterCountry = {
          //     id: player.addressInfo?player.addressInfo.countryId:'MYS',
          //     name: player.addressInfo?player.addressInfo.countryName:'Malaysia',
          // }
        });
      }, 750);
    } else if (this.userType === 'booking_agent') {
      this.selectClubType = 'single';
      this.courseType = 'club';

      this.clubInfo = null;
      this.courseInfo = createCourseInfo();
      if (this.partnerInfo && this.partnerInfo.country.id)
        this.filterCountry = this.partnerInfo.country;
    }
    this.initServerStatus();

    if (this.isClubSpecific) {
      this.selectClubType = 'single';
      this.courseType = 'club';

      console.debug(
        'init is club spec : ',
        this.selectedClub,
        this.mg2uUtil.getSelectedClub(),
        this.mg2uUtil.getClubMembership()
      );
      this.clubInfo = this.selectedClub;
      this.courseInfo = createCourseInfo();
    }
  }

  ionViewDidEnter() {
    if (this.userType === 'player') {
      if (this.refreshOnEnter) this._refreshValues(null, null);
      this.refreshOnEnter = false;
      if (this.bookings === 'mybookings') {
        this.refreshBookingHome(true);
      }
      this.refreshFavouriteClubs();
    }
    if (this.dataExtras?.startBooking) {
      this.openTeeTimeModal();
    }
  }
  subBookingByPlayer: Subscription;
  subBookingForPlayer: Subscription;
  ionViewWillLeave() {
    if (this.subBookingByPlayer) {
      this.subBookingByPlayer.unsubscribe;
      this.subBookingByPlayer = null;
    }
    if (this.subBookingForPlayer) {
      this.subBookingForPlayer.unsubscribe;
      this.subBookingForPlayer = null;
    }
  }

  async onBookNow() {
    let _clubName = this.clubInfo.clubName;
    let _teeOffTime = moment(this.fromTime, 'HH:mm:ss').format('hh:mm A');
    let _teeOffDate = moment(this.startDate).format('ddd, DD MMM YYYY');
    let _depositCutOffDays = this.bookingOptions ? this.bookingOptions.depositCutOffDays : 1;
    let _holdDate = moment(this.startDate)
      .subtract(_depositCutOffDays, 'days')
      .format('ddd, DD MMM YYYY');
    // let _Oldmessage = `You have requested to book the following:<br>
    let _depositAmount = 'payment';
    let _currency =
      this.clubInfo && this.clubInfo.country ? this.clubInfo.country.currencySymbol : '';

    if (
      this.bookingOptions &&
      this.appAttribute &&
      this.appAttribute.showDepoSecureMessage != false
    ) {
      if (this.bookingOptions.depositAmountType.toLowerCase() === 'percentage') {
        if (this.bookingOptions.depositAmount === 100) {
          _depositAmount = '<b>Full Payment</b>';
        } else if (this.bookingOptions.depositAmount === 50) {
          _depositAmount = '<b>Half Payment</b>';
        } else
          _depositAmount =
            '<b>' + this.bookingOptions.depositAmount + '% Payment of the Booking Amount</b>';
      } else if (this.bookingOptions.depositAmountType.toLowerCase() === 'absolute') {
        _depositAmount =
          'Deposit of ' + '<b>' + _currency + this.bookingOptions.depositAmount + '</b>';
      } else _depositAmount = 'payment';
    }
    let _messagePayment = '';
    let _avoidCancelMessage = 'To avoid cancellation,';
    let _additionalChargesMessage = '';
    let _message1 = '';
    let _message2 = '';
    if (
      this.appAttribute &&
      this.appAttribute.bookingRequest &&
      this.appAttribute.bookingRequest.avoidCancelMessage
    )
      _avoidCancelMessage = this.appAttribute.bookingRequest.avoidCancelMessage;
    if (
      this.appAttribute &&
      this.appAttribute.bookingRequest &&
      this.appAttribute.bookingRequest.additionalChargesMessage
    )
      _additionalChargesMessage = this.appAttribute.bookingRequest.additionalChargesMessage;
    if (_additionalChargesMessage && _additionalChargesMessage.length > 0)
      _additionalChargesMessage += `<br>`;

    if (moment(_holdDate).diff(moment(), 'days') <= 0) {
      if (moment(this.fromTime, 'HH:mm:ss').diff(moment(), 'minutes') <= 0) {
        if (
          this.bookingOptions.fullPaymentCutOffHours <= 0 &&
          this.appAttribute.bookingCutOffValue
        ) {
          _messagePayment =
            _avoidCancelMessage +
            ` you have <b>` +
            this.appAttribute.bookingCutOffValue +
            ' ' +
            this.appAttribute.bookingCutOffValuePeriod +
            `</b> to make full payment`;
        } else {
          _messagePayment =
            _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else if (moment(this.fromTime, 'HH:mm:ss').diff(moment(), 'minutes') > 0) {
        if (this.bookingOptions.fullPaymentCutOffHours > 0) {
          _messagePayment =
            _avoidCancelMessage +
            ` you have <b>` +
            this.bookingOptions.fullPaymentCutOffHours +
            ` hour(s)</b> to make Full Payment before tee off time`;
        } else {
          _messagePayment =
            _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
        }
      } else {
        _messagePayment =
          _avoidCancelMessage + ` you have <b>` + '60 minutes' + `</b> to make full payment`;
      }
    } else {
      _messagePayment =
        _avoidCancelMessage +
        ` you will need to make ` +
        _depositAmount +
        ` before <b style="color:green">` +
        _holdDate +
        `</b> at <b style="color:green">` +
        _teeOffTime +
        `</b>.<br>`;
    }

    let _message =
      _clubName +
      `
    <br>Date: ` +
      _teeOffDate +
      `
    <br>Time: ` +
      _teeOffTime +
      `<br>Total Player(s): ` +
      `1` +
      `<br><br>` +
      _additionalChargesMessage +
      _messagePayment;

    let alert = await this.alertCtrl.create({
      header: 'Booking Confirmation',
      message: _message,
      cssClass: 'booking-alert',
      buttons: [
        {
          text: 'Not Now',
          role: 'cancel',
          handler: () => {},
        },
        {
          text: 'Confirm',
          handler: () => {
            this._goBookNow();
          },
        },
      ],
    });
    alert.present();
  }

  bookingNextMonth: number = 3;
  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter(d => {
            return d.page === 'bookingHome';
          })
          .map(d => {
            this.appAttribute = d;
          });
        if (this.appAttribute.filters) {
          this.fromTime = this.appAttribute.filters.fromTime;
          this.toTime = this.appAttribute.filters.toTime;
          if (!this.isClubSpecific && this.userType !== 'booking_agent')
            this.selectClubType = this.appAttribute.filters.selectClubType;
        }
        this.useHistorical = this.appAttribute.historical;
        if (this.appAttribute.enableNearby) this.enableNearby = this.appAttribute.enableNearby;
        if (this.appAttribute.bookingStatus.noneToPayShort)
          this.noneToPayShort = this.appAttribute.bookingStatus.noneToPayShort;
        if (this.appAttribute.filters?.nextMonth)
          this.bookingNextMonth = this.appAttribute.filters.nextMonth;
      }
    });
  }

  setFriendType(type: number) {
    if (type === 1) {
      this.friendType = 'friend';
      this.friendScreenName = 'Friends';
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
    if (type === 2) {
      this.friendType = 'request';
      this.friendScreenName = 'Requests';
      this._refreshRequest(null, null);
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
    if (type === 3) {
      this.friendType = 'find';
      this.friendScreenName = 'Find | Add';
      this.playerList = createPlayerList();
      this._refreshPlayer(null, null);
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
  }

  setBookingType(type: number) {
    if (type === 1) {
      this.bookings = 'search';
      this.friendScreenName = 'Search';
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
      this.initServerStatus();
    }
    if (type === 2) {
      this.bookings = 'mybookings';
      this.refreshBookingHome(true);
      this.friendScreenName = 'My Bookings';
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    }
  }

  initServerStatus() {
    this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
      if (data) {
        this.botsOut = data.botsOut;
        //this.botsOut = true;
      }
    });
    this.refreshFavouriteClubs();
  }

  disableQuickbook() {
    if (this.appAttribute && this.appAttribute.disableQuickbook) return true;
    else return false;
  }

  doInfinite(infinite) {
    if (this.isMore()) {
      this._refreshPlayer(null, infinite);
    } else {
      infinite.target.complete();
      // infinite.enable(false);
    }
  }
  displayQuickbookingMessage() {
    if (this.appAttribute && this.appAttribute.showQuickbookCheck) return true;
    else return false;
  }
  public isMore() {
    return (
      this.playerList.totalPages > 0 && this.playerList.currentPage < this.playerList.totalPages
    );
  }

  onPlayerInput(searchbar) {
    this.playerList = createPlayerList();
    this._refreshPlayer(null, null);
  }

  onRefresh(refresher) {
    this._refreshValues(refresher, null);
  }

  async openNewContact() {
    const newContact: any = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        openedModal: true,
      },
    });

    newContact.onDidDismiss((apply: any) => {
      // if (apply) {

      this._refreshFriends(null, null);
      // }
    });
    newContact.present();
  }

  searchNewContact() {
    this.router.navigate(['search-player-list']);
  }

  getCourseName(): string {
    let courseName = 'Tap here';

    // return courseName;
    if (this.courseInfo && this.courseInfo.courseName) return this.courseInfo.courseName;
    else return courseName;
  }

  async friendSelected(event, item: PlayerInfo) {
    const modal: any = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'friend',
        type: 'friendProfile',
        player: of(item),
        openedModal: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      // adjustViewZIndex(this.nav, this.renderer);
      if (data) {
        if (data.data.type == 'requestFriend') {
          this.friends = 'request';
          this._refreshValues(null, null);
        }
        if (data.data.type == 'acceptFriend') this._refreshValues(null, null);

        if (data.data.type == 'deleteFriend') {
          this._refreshValues(null, null);
        }
        if (data.data.type == 'deleteRequest') {
          this._refreshValues(null, null);
        }
      }
    });
    modal.present();
    // this.events.publish("friendSelected", item);
    // this.nav.push(ProfilePage, {
    //     status: 'friend',
    //     type: 'friendProfile',
    //     player: item,
    //     homeInfo: this.homeInfo
    // });
  }

  async requestSelected(event, item: FriendRequest) {
    const modal: any = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        requestByPlayer: item.requestByPlayer,
        status: 'pendingFriend',
        type: 'friendProfile',
        player: of(item.player),

        openedModal: true,
      },
    });
    modal.onDidDismiss((data: any) => {
      if (data) {
        //
        if (data.data.type == 'requestFriend') {
          this.friends = 'request';
          this._refreshValues(null, null);
        }
        if (data.data.type == 'acceptFriend') {
          this.friends = 'friend';
          this._refreshValues(null, null);
        }
        if (data.data.type == 'deleteFriend') {
          this._refreshValues(null, null);
        }
        if (data.data.type == 'deleteRequest') {
          this._refreshValues(null, null);
        }
      }
    });
    modal.present();

    // this.nav.push(ProfilePage, {
    //     requestByPlayer: item.requestByPlayer,
    //     status: 'pendingFriend',
    //     type: 'friendProfile',
    //     player: item.player,
    //     homeInfo: this.homeInfo
    // });
  }

  onActiveBookingClick(x: TeeTimeBooking) {
    this.navigationExtras = {
      // replaceUrl: false,
      state: {
        clubInfo: x.clubData,
        teeSlotNew: false,
        teeTimeSlotDisplay: x.slotAssigned,
        bookingSlot: x,
      },
    };
    this.router.navigate(['booking-details'], this.navigationExtras);
  }
  onPastBookingClick(x: TeeTimeBooking) {
    this.navigationExtras = {
      // replaceUrl: false,
      state: {
        clubInfo: x.clubData,
        teeSlotNew: false,
        teeTimeSlotDisplay: x.slotAssigned,
        bookingSlot: x,
        type: 'past',
      },
    };
    this.router.navigate(['booking-details'], this.navigationExtras);
  }

  onInvitedBookingClick(x: TeeTimeBooking) {
    this.navigationExtras = {
      // replaceUrl: false,
      state: {
        clubInfo: x.clubData,
        teeSlotNew: false,
        teeTimeSlotDisplay: x.slotAssigned,
        bookingSlot: x,
      },
    };
    this.router.navigate(['/tabs/booking-details'], this.navigationExtras);
  }

  onCancelBookingClick(x: TeeTimeBooking) {
    this.navigationExtras = {
      replaceUrl: false,
      state: {
        clubInfo: x.clubData,
        teeSlotNew: false,
        teeTimeSlotDisplay: x.slotAssigned,
        bookingSlot: x,
        type: 'past',
      },
    };
    this.router.navigate(['/tabs/booking-details'], this.navigationExtras);
  }
  onCompletedBookingClick() {
    this.router.navigate(['/tabs/booking-details']);
  }
  onPendingBookingClick() {
    this.router.navigate(['/tabs/booking-details']);
  }

  refreshFavouriteClubs() {
    this.favClubs = [];
    this.playerService.getFavoriteClubs(false).subscribe(
      (favourites: any) => {
        this.favClubs = favourites;
      },
      error => {},
      () => {}
    );
  }

  addDate(value) {
    // if(value < 0)
    let date = this.startDate;
    date = moment(date).add(value, 'd').format('YYYY-MM-DD');
    if (date < this.today) {
      // this.commonProvider.showToast('Selecting earlier date is not allowed', false, 500, 'danger');
      MessageDisplayUtil.showMessageToast(
        'Selecting earlier date is not allowed',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );

      return;
    }
    this.startDate = date;
  }

  async onSelectTimes() {
    const modal = await this.modalCtl.create({
      component: SelectDatesPage,
      componentProps: {
        type: 'times',
        range: true,
        fromTime: this.fromTime,
        toTime: this.toTime,
      },
      id: 'SelectDatesPage',
    });

    modal.onDidDismiss().then(res => {
      if (res.data) {
        this.fromTime = res.data.fromTime;
        this.toTime = res.data.toTime;
      }
    });
    modal.present();
  }

  async onSelectDates() {
    let dates: any = await this.modalCtl.create({
      component: SelectDatesPage,
      componentProps: {
        type: 'dates',
        range: false,
        startDate: this.startDate,
        endDate: this.endDate,
      },
      id: 'SelectDatesPage',
    });

    dates.onDidDismiss().then((data: any) => {
      if (data) {
        this.startDate = data.startDate;
        this.endDate = data.endDate;
      }
    });

    dates.present();
  }

  private async _refreshRequest(refresher, infinite) {
    this.refreshAttempted = false;

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.present().then(() => {
      this.refreshAttempted = false;
      this.friendService.searchFriendRequests().subscribe(
        (friendRequests: FriendRequestList) => {
          loader.dismiss(friendRequests).then(() => {
            this.refreshAttempted = true;

            if (friendRequests) {
              this.requestFriends = friendRequests;
              this.receivedRequest();
              this.sentRequest();
            }

            if (this.sentList.length > 0) {
              this.sentExist = true;
            }

            if (this.receivedList.length > 0) {
              this.receiveExist = true;
            }

            if (this.platform.is('ios') && this.platform.is('capacitor')) {
              this.keyboard.hide();
            }
          });
        },
        error => {
          loader.dismiss();
        },
        () => {
          if (refresher) {
            refresher.complete();
          }
          if (infinite) {
            infinite.complete();
          }
        }
      );
    });
  }

  private async _refreshFriends(refresher, infinite) {
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.present().then(() => {
      this.refreshAttempted = false;
      this.friendService.searchFriends(this.searchFriend).subscribe(
        (friendRequests: PlayerList) => {
          loader.dismiss(friendRequests).then(() => {
            this.refreshAttempted = true;

            if (friendRequests) {
              this.listFriends = friendRequests;
            }
          });
        },
        error => {
          loader.dismiss();
        },
        () => {
          if (refresher) {
            refresher.complete();
          }
          if (infinite) {
            infinite.target.complete();
          }
        }
      );
    });
  }

  private async _refreshPlayer(refresher, infinite) {
    this.refreshPlayer = false;

    if (!this.searchPlayer || this.searchPlayer == '') {
      this.refreshPlayer = false;
      return false;
    }

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    loader.present().then(() => {
      this.friendService
        .searchNonFriends(this.searchPlayer, this.playerList.currentPage + 1)
        .subscribe(
          (playerList: PlayerList) => {
            loader.dismiss(playerList).then(() => {
              if (playerList.totalPages > 0) this.playerList.currentPage++;

              this.refreshPlayer = true;

              if (playerList) {
                this.playerList.currentPage = playerList.currentPage;
                this.playerList.totalPages = playerList.totalInPage;
                this.playerList.totalItems = playerList.totalItems;
                this.playerList.players.push(...playerList.players);
              }
              if (this.platform.is('ios') && this.platform.is('cordova')) {
                this.keyboard.hide();
              }
            });
          },
          error => {
            loader.dismiss();
          },
          () => {
            if (refresher) {
              refresher.complete();
            }
            if (infinite) {
              infinite.target.complete();
            }
          }
        );
    });
  }

  async playerSelected(event, item: PlayerInfo) {
    const modal: any = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'notFriend',
        type: 'friendProfile',
        player: of(item),
        // homeInfo: this.homeInfo,
        openedModal: true,
      },
    });
    modal.onDidDismiss((data: any) => {
      // adjustViewZIndex(this.nav, this.renderer);
      if (data) {
        if (data.data.type == 'requestFriend') {
          this.friends = 'request';
          //   this._refreshValues(null, null);
        }
        if (data.data.type == 'acceptFriend') {
          this.friends = 'friend';
          //      this._refreshValues(null, null);
        }
        if (data.data.type == 'deleteFriend') {
          //        this._refreshValues(null, null);
        }
        if (data.data.type == 'deleteRequest') {
          //         this._refreshValues(null, null);
        }
      }
    });
    modal.present();
    // this.events.publish("playerSelected", item);
    // this.nav.push(ProfilePage, {
    //     status: 'notFriend',
    //     type: 'friendProfile',
    //     player: item,
    //     homeInfo: this.homeInfo
  }

  receivedRequest() {
    this.receivedList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return !req.requestByPlayer;
    });
  }

  sentRequest() {
    this.sentList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return req.requestByPlayer;
    });
  }

  getCurrentLocation() {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
  }

  async goCoursePicklist() {
    let _courseId;
    let _courseName;
    if (this.userType === 'booking_agent') {
      this.onClubPicklist()
        .then((result: any) => {
          if (result && result.status === 'success') {
            this.clubInfo = result.clubInfo;
            this.courseInfo = createCourseInfo();
            // this.nav.push(TeeTimeSlotsPage, {
            //     clubId: result.clubInfo.clubId,
            //     fromClub: true,
            // })
          }

          // if (!data) {
          //     return false;
          // }
          // if (data.apply) {
          //     this.courseInfo = data.courseInfo;
          //     this.clubInfo = data.clubInfo;

          //     // this.clubName = clubName;
          //     // this.clubName = clubInfo.clubName;
          //     _courseId = this.courseInfo.courseId;
          //     _courseName = this.courseInfo.courseName;
          // }
        })
        .catch(error => {});
    } else if (1) {
      // this.nav.push(PerformanceClubListPage);
      /*, {
       courseId: this.courseId,
       courseName: this.courseName
       });*/

      const club: any = await this.modalCtl.create({
        component: RecentClubPage,
        componentProps: {
          //analysisType: "analysis",
          courseInfo: this.courseInfo,
          openedModal: true,
          courseType: this.courseType,
          clubInfo: this.clubInfo,
        },
        id: 'RecentClubPage',
      });

      if (this.courseType == 'course') {
        club.onDidDismiss().then((data: any) => {
          if (!data) {
            return false;
          }
          if (data.apply) {
            this.courseInfo = data.courseInfo;
            this.clubInfo = data.clubInfo;

            // this.clubName = clubName;
            // this.clubName = clubInfo.clubName;
            _courseId = this.courseInfo.courseId;
            _courseName = this.courseInfo.courseName;
          }
        });
      } else if (this.courseType == 'club') {
        club.onDidDismiss().then((data: any) => {
          let cnt = 0;
          if (data.data.clubInfo) {
            this.clubInfo = data.data.clubInfo;
            cnt++;
          }
          if (cnt == 0) {
            this.clubInfo = data.data;
          }
          this.courseInfo = createCourseInfo();
          // this.clubName = this.clubInfo.clubName;
        });
      }
      club.present();
    } else {
      _courseId = null;
      _courseName = 'Please choose a course';
    }
  }

  getClubName(): string {
    let clubName = 'Tap here to select a club';
    if (this.clubInfo && this.clubInfo.clubName) return this.clubInfo.clubName;
    else return clubName;
  }
  clearClubSelection() {
    this.clubInfo = createClubInfo();
  }

  getClubImage(club: ClubInfo) {
    //   if (club) {
    //     return club.clubImage;
    //   }
    //   else {
    //     return 'src/assets/image/default_club.png'
    //   }
    if (!club) return 'assets/image/default_club.png';
    let _club = JSON.parse(JSON.stringify(club));
    JsonService.deriveFullUrl(_club, 'clubImage');
    JsonService.deriveFullUrl(_club, 'clubLogo');
    JsonService.deriveFullUrl(_club, 'clubThumbnail');

    if (_club && _club.clubThumbnail) return _club.clubThumbnail;
    else if (_club && _club.clubImage) return _club.clubImage;
    else if (_club && _club.clubLogo) return _club.clubLogo;
    else return 'assets/image/default_club.png';
  }

  setupFavClubs() {
    this.router.navigate(['player-favourite-list']);
    // let _message = ';';
    // let alert = this.alertCtrl.create({
    //     title: 'Setup Fav Clubs',
    //     // subTitle: 'Selected date is '+ _date,
    //     message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
    //     buttons: ['Close']
    // });
    // alert.present();
  }

  onRecaptchaToolTip() {
    let _message = `This site is protected by reCAPTCHA and the Google
  <a href="https://policies.google.com/privacy">Privacy Policy</a> and
  <a href="https://policies.google.com/terms">Terms of Service</a> apply.`;
    let alert = this.alertCtrl
      .create({
        header: 'Google reCAPTCHA info',
        message: _message,
        buttons: ['Close'],
      })
      .then(res => {
        res.present();
      });
  }

  async goSearchTeeTimes() {
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
      backdropDismiss: true,
      // dismissOnPageChange
      // duration: 5000,
    });
    let _favClubs;
    let _countryId = this.filterCountry ? this.filterCountry.id : null;
    let _location = this.filteredLocation;
    if (this.selectClubType === 'single' && (!this.clubInfo || !this.courseInfo)) {
      let _message = 'Please select a single club';
      let alert = this.alertCtrl
        .create({
          header: 'Search option',
          message: _message,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    } else if (
      this.selectClubType === 'favClubs' &&
      ((this.favClubs && this.favClubs.length === 0) || !this.favClubs)
    ) {
      let _message = 'No Favourite clubs found. Please tap on SET UP to define your favourites.';
      let alert = this.alertCtrl
        .create({
          header: 'Search by Favourite Club(s)',
          // subTitle: 'Selected date is '+ _date,
          message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    } else if (
      this.selectClubType === 'location' &&
      ((this.filteredLocation && this.filteredLocation.length === 0) || !this.filteredLocation)
    ) {
      let _message = 'Please enter a location name';
      let alert = await this.alertCtrl.create({
        header: 'Search by Location',
        // subTitle: 'Selected date is '+ _date,
        message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
        buttons: ['Close'],
      });
      alert.present();
      return false;
    }
    let _forDate = moment(this.startDate).format('YYYY-MM-DD');
    let _fromTime = this.fromTime; //'07:00';
    let _toTime = this.toTime; //'09:00';
    let _clubCourseId;
    let _isClub: boolean = true;
    loader.present().then(() => {
      let _bookingListType = this.selectClubType; //'single';

      let _playerId;
      if (this.userType === 'player')
        this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
          _playerId = player.playerId;
        });
      if (_bookingListType === 'single') {
        if (this.courseType === 'club') {
          _clubCourseId = this.clubInfo.clubId;
          _isClub = true;
        } else if (this.courseType === 'course') {
          _clubCourseId = this.courseInfo.courseId;
          _isClub = false;
        }
        let _pageSize;
        let _partnerId = this.partnerInfo ? this.partnerInfo.id : null;
        // loader.dismiss().then(() => {
        this.flightService
          .getSearchAllSlots(
            _forDate,
            _fromTime,
            _toTime,
            _pageSize,
            null,
            _partnerId,
            _clubCourseId,
            _countryId,
            null,
            _location
          )
          // .subscribe((teeTimeSlotDayDisplay: Array<TeeTimeSlotDisplay>) => {
          .subscribe(
            async (data: any) => {
              let teeTimeSlotDayDisplay;
              let _slotStats = data.resp;
              if (_slotStats && _slotStats.totalPages === 0) {
                console.debug(
                  'search all slots : ',
                  this.selectedClub,
                  this.clubInfo,
                  this.isClubSpecific
                );
                let _clubName = this.clubInfo?.name || this.clubInfo?.clubName;
                let _message =
                  _clubName +
                  '<br>Date : ' +
                  moment(_forDate).format('ddd, DD MMM YYYY') +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                if (this.filterCountry && this.filterCountry.name)
                  _message += '<br>Country : ' + this.filterCountry.name;
                // if(teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0) {
                //     if( teeTimeSlotDayDisplay[0].reasonsForUnavailability[0])
                //         _message += '<br>' + teeTimeSlotDayDisplay[0].reasonsForUnavailability[0]
                // }
                let alert = await this.alertCtrl.create({
                  header: 'No Tee Time slots',
                  // subTitle: 'Selected date is '+ _date,
                  message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
                // if (this.loader) this.loader.dismiss();
                return false;
              }

              if (data.teeTimeSlot) teeTimeSlotDayDisplay = data.teeTimeSlot[0].slots; //teeTimeSlotDayDisplay
              // this.loader.dismiss().then(()=>{

              let _hasAvailable;
              if (teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0)
                _hasAvailable = teeTimeSlotDayDisplay.find(slots => {
                  return slots.available;
                });

              if (
                teeTimeSlotDayDisplay.length > 0 &&
                ((_hasAvailable && _hasAvailable.available) ||
                  this.mg2uUtil.getUserType() === 'booking_agent')
              ) {
                this.navigationExtras.state = {
                  bookingListType: _bookingListType,
                  teeTimeSlotDisplayList: teeTimeSlotDayDisplay,
                  fromTime: _fromTime,
                  toTime: _toTime,
                  startDate: _forDate,
                  courseInfo: this.courseInfo,
                  clubInfo: this.clubInfo,
                  fromClub: false,
                  userType: this.userType,
                  partnerInfo: this.partnerInfo,
                  clubTeeTimeSlotList: data.teeTimeSlot[0],
                  totalPages: _slotStats.totalPages,
                };
                this.router.navigate(['booking-list'], this.navigationExtras);
              } else {
                let _message =
                  this.clubInfo.clubName +
                  '<br>Date : ' +
                  moment(_forDate).format('ddd, DD MMM YYYY') +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                if (teeTimeSlotDayDisplay && teeTimeSlotDayDisplay.length > 0) {
                  if (teeTimeSlotDayDisplay[0].reasonsForUnavailability[0])
                    _message += '<br>' + teeTimeSlotDayDisplay[0].reasonsForUnavailability[0];
                }
                let alert = await this.alertCtrl.create({
                  header: 'No Tee Time slots',
                  // subTitle: 'Selected date is '+ _date,
                  message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
                  buttons: ['Close'],
                });
                alert.present();
              }
              if (loader) loader.dismiss().then(() => {});
              // })
            },
            error => {
              if (loader) loader.dismiss().then(() => {});
            },
            () => {
              if (loader) loader.dismiss().then(() => {});
              // setTimeout(()=>{
              //     this.loader.dismiss()
              // }, 5000)
            }
          );
        // });
      } else if (_bookingListType === 'nearbyClubs') {
        let lat1 = this.geo.getLatitude();
        let lon1 = this.geo.getLongitude();

        if (lat1 === null || lon1 === null) {
          MessageDisplayUtil.showMessageToast(
            'GPS co-ordinates are not provided. Please make sure location service is on',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          if (loader) loader.dismiss().then(() => {});
          return false;
        } else {
          loader.dismiss().then(() => {
            this.flightService
              .getTeeTimeSlotNearbyClubs(_forDate, this.searchDistance, _fromTime, _toTime)
              .subscribe(
                (clubTeeTimeSlots: Array<ClubTeeTimeSlots>) => {
                  if (clubTeeTimeSlots.length > 0) {
                    if (clubTeeTimeSlots)
                      clubTeeTimeSlots.sort((a, b) => {
                        if (a.distance < b.distance) return -1;
                        else if (b.distance < a.distance) return 1;
                        else return 0;
                      });
                    if (this.mg2uUtil.getUserType() === 'booking_agent') {
                      this.navigationExtras.state = {
                        bookingListType: _bookingListType,
                        clubTeeTimeSlotList: clubTeeTimeSlots,
                        fromTime: _fromTime,
                        toTime: _toTime,
                        startDate: _forDate,
                        courseInfo: this.courseInfo,
                        clubInfo: this.clubInfo,
                        playerId: _playerId,
                        fromClub: false,
                        searchDistance: this.searchDistance,
                        filterCountry: this.filterCountry,
                        filteredLocation: this.filteredLocation,
                      };
                      this.router.navigate(['booking-club-list'], this.navigationExtras);
                      if (loader) loader.dismiss();
                    } else {
                      this.flightService
                        .getListPlayerVouchers(_playerId)
                        .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
                          if (playerVoucher && playerVoucher.length > 0) {
                            this.navigationExtras.state = {
                              bookingListType: _bookingListType,
                              clubTeeTimeSlotList: clubTeeTimeSlots,
                              fromTime: _fromTime,
                              toTime: _toTime,
                              startDate: _forDate,
                              courseInfo: this.courseInfo,
                              clubInfo: this.clubInfo,
                              playerVoucher: playerVoucher,
                              playerId: _playerId,
                              fromClub: false,
                              searchDistance: this.searchDistance,
                              filterCountry: this.filterCountry,
                              filteredLocation: this.filteredLocation,
                            };
                            this.router.navigate(['booking-club-list'], this.navigationExtras);
                          } else {
                            this.navigationExtras.state = {
                              bookingListType: _bookingListType,
                              clubTeeTimeSlotList: clubTeeTimeSlots,
                              fromTime: _fromTime,
                              toTime: _toTime,
                              startDate: _forDate,
                              courseInfo: this.courseInfo,
                              clubInfo: this.clubInfo,
                              playerId: _playerId,
                              fromClub: false,
                              searchDistance: this.searchDistance,
                              filterCountry: this.filterCountry,
                              filteredLocation: this.filteredLocation,
                            };
                            this.router.navigate(['booking-club-list'], this.navigationExtras);
                          }
                          if (loader) loader.dismiss();
                        });
                    }
                  } else {
                    let _message =
                      this.clubInfo.clubName +
                      '<br>Date : ' +
                      _forDate +
                      '<br>From ' +
                      _fromTime +
                      ' to ' +
                      _toTime;
                    let alert = this.alertCtrl
                      .create({
                        header: 'Search by Single Club',
                        message: _message,
                        buttons: ['Close'],
                      })
                      .then(res => {
                        res.present();
                      });
                    loader.dismiss();
                  }
                },
                error => {
                  let _error = error;
                  if (error.status === 409) {
                    let _message = _error.errors[0];
                    let alert = this.alertCtrl
                      .create({
                        header: 'Search by Single Club',
                        message: _message,
                        buttons: ['Close'],
                      })
                      .then(res => {
                        res.present();
                      });
                  }
                  if (loader) loader.dismiss().then(() => {});
                },
                () => {
                  if (loader) loader.dismiss().then(() => {});
                }
              );
          });
        }
      } else if (_bookingListType === 'favClubs') {
        this.flightService.getTeeTimeSlotFavClubs(_forDate, _fromTime, _toTime).subscribe(
          (data: any) => {
            // clubTeeTimeSlots : Array<ClubTeeTimeSlots>
            // loader.dismiss().then(() => {
            if (data && data.teeTimeSlot) {
              let clubTeeTimeSlots: Array<ClubTeeTimeSlots> = data.teeTimeSlot;

              if (clubTeeTimeSlots.length > 0) {
                this.flightService
                  .getListPlayerVouchers(_playerId)
                  .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
                    if (playerVoucher && playerVoucher.length > 0) {
                      this.navigationExtras.state = {
                        bookingListType: _bookingListType,
                        clubTeeTimeSlotList: clubTeeTimeSlots,
                        fromTime: _fromTime,
                        toTime: _toTime,
                        startDate: _forDate,
                        courseInfo: this.courseInfo,
                        clubInfo: this.clubInfo,
                        playerVoucher: playerVoucher,
                        playerId: _playerId,
                        fromClub: false,
                        filterCountry: this.filterCountry,
                        filteredLocation: this.filteredLocation,
                      };
                      this.router.navigate(['booking-club-list'], this.navigationExtras);
                    } else {
                      this.navigationExtras.state = {
                        bookingListType: _bookingListType,
                        clubTeeTimeSlotList: clubTeeTimeSlots,
                        fromTime: _fromTime,
                        toTime: _toTime,
                        startDate: _forDate,
                        courseInfo: this.courseInfo,
                        clubInfo: this.clubInfo,
                        fromClub: false,
                        filterCountry: this.filterCountry,
                        filteredLocation: this.filteredLocation,
                      };
                      this.router.navigate(['booking-club-list'], this.navigationExtras);
                    }
                  });
              } else {
                let _message =
                  'No Tee Time slots for <br>Date : ' +
                  _forDate +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                let alert = this.alertCtrl
                  .create({
                    header: 'Search by Favourite Club(s)',
                    message: _message,
                    buttons: ['Close'],
                  })
                  .then(res => {
                    res.present();
                  });
                if (loader) loader.dismiss().then(() => {});
              }
            }
            if (loader) loader.dismiss().then(() => {});
            // });
          },
          error => {
            let _error = error;
            if (error.status === 409) {
              let _message = _error.errors[0].includes('favorite clubs')
                ? 'No Favourite clubs found. Please tap on SET UP to define your favourites.'
                : _error.errors[0];
              let alert = this.alertCtrl
                .create({
                  header: 'Search by Favourite Club(s)',
                  message: _message,
                  buttons: ['Close'],
                })
                .then(res => {
                  res.present();
                });
            }
            if (loader) loader.dismiss().then(() => {});
          },
          () => {
            setTimeout(() => {
              if (loader) loader.dismiss().then(() => {});
            }, 5000);
          }
        );
      } else if (
        _bookingListType === 'allClubs' ||
        _bookingListType === 'location' ||
        _bookingListType === 'recentClubs'
      ) {
        let _serviceCall;
        // if(this.userType === 'player') _serviceCall = this.flightService.getListAllSlots(_playerId,_forDate,_fromTime,_toTime)
        // if(this.userType === 'booking_agent')
        let _pageSize = 5;
        let _partner = this.partnerInfo ? this.partnerInfo.id : null;
        _serviceCall = this.flightService.getSearchAllSlots(
          _forDate,
          _fromTime,
          _toTime,
          _pageSize,
          null,
          _partner,
          null,
          _countryId,
          null,
          this.filteredLocation
        );
        // loader.dismiss().then(() => {
        _serviceCall.subscribe(
          async (data: any) => {
            // clubTeeTimeSlots : Array<ClubTeeTimeSlots>
            if (data && data.teeTimeSlot) {
              let _slotStats = data.resp;
              let clubTeeTimeSlots: Array<ClubTeeTimeSlots> = data.teeTimeSlot;

              if (clubTeeTimeSlots.length > 0) {
                if (this.userType === 'player') {
                  this.flightService
                    .getListPlayerVouchers(_playerId)
                    .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
                      if (playerVoucher && playerVoucher.length > 0) {
                        this.navigationExtras.state = {
                          bookingListType: _bookingListType,
                          clubTeeTimeSlotList: clubTeeTimeSlots,
                          fromTime: _fromTime,
                          toTime: _toTime,
                          startDate: _forDate,
                          courseInfo: this.courseInfo,
                          clubInfo: this.clubInfo,
                          playerVoucher: playerVoucher,
                          playerId: _playerId,
                          fromClub: false,
                          partnerInfo: this.partnerInfo,
                          totalPages: _slotStats.totalPages,
                          filterCountry: this.filterCountry,
                          filteredLocation: this.filteredLocation,
                        };
                        this.router.navigate(['booking-club-list'], this.navigationExtras);
                      } else {
                        this.navigationExtras.state = {
                          bookingListType: _bookingListType,
                          clubTeeTimeSlotList: clubTeeTimeSlots,
                          fromTime: _fromTime,
                          toTime: _toTime,
                          startDate: _forDate,
                          courseInfo: this.courseInfo,
                          clubInfo: this.clubInfo,
                          playerId: _playerId,
                          fromClub: false,
                          partnerInfo: this.partnerInfo,
                          totalPages: _slotStats.totalPages,
                          filterCountry: this.filterCountry,
                          filteredLocation: this.filteredLocation,
                        };
                        this.router.navigate(['booking-club-list'], this.navigationExtras);
                      }
                    });
                } else {
                  this.navigationExtras.state = {
                    bookingListType: _bookingListType,
                    clubTeeTimeSlotList: clubTeeTimeSlots,
                    fromTime: _fromTime,
                    toTime: _toTime,
                    startDate: _forDate,
                    courseInfo: this.courseInfo,
                    clubInfo: this.clubInfo,
                    // playerId: _playerId,
                    fromClub: false,
                    userType: this.userType,
                    partnerInfo: this.partnerInfo,
                    totalPages: _slotStats.totalPages,
                    filterCountry: this.filterCountry,
                    filteredLocation: this.filteredLocation,
                  };
                  this.router.navigate(['booking-club-list'], this.navigationExtras);
                }
              } else {
                let _message =
                  'No Tee Time slots for <br>Date : ' +
                  _forDate +
                  '<br>From ' +
                  _fromTime +
                  ' to ' +
                  _toTime;
                if (this.filterCountry && this.filterCountry.name)
                  _message += '<br>Country : ' + this.filterCountry.name;
                let alert = await this.modalCtl.create({
                  component: DeleteRoomModalComponent,
                  showBackdrop: true,
                  mode: 'ios',
                  cssClass: this.platform.is('mobile')
                    ? 'self-adjustable-modal'
                    : 'self-adjustable-modal-desktop',
                  componentProps: {
                    header: 'Search by All Club(s)',
                    msg: _message,
                    mode: 'serachByAllClub',
                  },
                });
                await alert.present().then(() => {
                  const height = this.platform.height() - 180;
                  document.getElementsByClassName('inner-content')[0]['style'].maxHeight =
                    `${height}px`;
                });
              }
            }
            if (loader) loader.dismiss().then(() => {});
            if (_serviceCall) {
              _serviceCall.unsubscribe();
              _serviceCall = null;
            }
          },
          error => {
            let _error = error;
            if (error.status === 409) {
              let _message = _error.errors[0].includes('favorite clubs')
                ? 'No Favourite clubs found. Please tap on SET UP to define your favourites.'
                : _error.errors[0];
              let alert = this.alertCtrl
                .create({
                  header: 'Search by Favourite Club(s)',
                  message: _message,
                  buttons: ['Close'],
                })
                .then(res => {
                  res.present();
                });
            }
            if (loader) loader.dismiss().then(() => {});
            if (_serviceCall) {
              _serviceCall.unsubscribe();
              _serviceCall = null;
            }
          }
          // complete: () => {
          // setTimeout(() => {
          //   loader.dismiss();
          // }, 5000)
          // },
        );
        // });
      }
    });
    // 310510219 afamosa course id
  }

  goQuickBook() {
    if (this.selectClubType !== 'single') {
      let _message = 'Please select a club';
      let alert = this.alertCtrl
        .create({
          header: 'Quick book option',
          message: _message,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    }
    if (!this.clubInfo || !this.courseInfo) {
      let _message = 'Please select a club';
      let alert = this.alertCtrl
        .create({
          header: 'Quick book option',
          message: _message,
          buttons: ['Close'],
        })
        .then(res => {
          res.present();
        });
      return false;
    }
    this.checkClubBookingOption();
    // this.onBookNow();
  }
  // onBookNow() {
  //   let _clubName = this.clubInfo.clubName;
  //   let _teeOffTime = moment(this.fromTime, "HH:mm:ss").format("hh:mm A");
  //   let _teeOffDate = moment(this.startDate).format("ddd, DD MMM YYYY")
  //   let _holdDate = moment(this.startDate).subtract(1, 'days').format("ddd, DD MMM YYYY");
  //   let _message = _clubName + `
  // <br>Date: ` + _teeOffDate + `
  // <br>Time: ` + _teeOffTime + `<br><br>

  // To avoid cancellation, you will need to make payment before <b style="color:green">` + _holdDate + `</b> at <b style="color:green">` + _teeOffTime + `</b>.<br>`;

  //   let alert = this.alertCtrl.create({
  //     header: 'Booking Confirmation',
  //     message: _message,
  //     cssClass: 'booking-alert',
  //     buttons: [{
  //       text: 'Not Now',
  //       role: 'cancel',
  //       handler: () => {

  //       }
  //     },
  //     {
  //       text: 'Confirm',
  //       handler: () => {

  //         // this.captchaResponse = captchaResponse;
  //         // if(this.captchaResponse.length > 0) this.goQuickBook();
  //         this._goBookNow();
  //       }
  //     }
  //     ]
  //   }).then(res => {
  //     res.present();
  //   });
  // }

  _goBookNow() {
    let _totalPlayers = 1; //this.teeTimeSlotDisplay.slot.maxPlayers;
    let _teeOffDate = moment(this.startDate).format('YYYY-MM-DD');
    let _fromTime = moment(this.fromTime, 'HH:mm:ss').format('HH:mm');
    let _toTime = moment(this.toTime, 'HH:mm:ss').format('HH:mm');
    let _ninesPlaying = parseInt('2'); //parseInt(this.holesPlayed);

    let _bookingName;
    let _bookingEmail;
    let _bookingPhone;
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$
      .pipe(filter(Boolean))
      .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _bookingName = player.playerName;
      _bookingEmail = player.email;
      _bookingPhone = player.phone;
    });
    let _addBookingPlayer = this.mg2uUtil.getUserType() === 'booking_agent' ? false : true;
    let reqBookSlot = {
      clubId: this.clubInfo.clubId,
      teeOffDate: _teeOffDate,
      teeOffTimeFrom: _fromTime,
      teeOffTimeTo: _toTime,
      totalPlayers: _totalPlayers,
      buggyRequired: 0,
      caddiesRequired: 0,
      ninesPlaying: _ninesPlaying,
      bookingName: _bookingName,
      bookingEmail: _bookingEmail,
      bookingPhone: _bookingPhone,
      bookingRequestedAt: null,
      addBookingPlayer: _addBookingPlayer,
    };

    // this.captchaResponse="03AGdBq253ZtaVzyh30npwWFLYpg8GN82d4K0lgvI0kgc0ZIDhDc-b25Xm1XscWyyLkfgY1FfV59kOKk3GNn1Yq-8_izmBcue1ScHdDkqBK0Wkkv9Q4wsToH_Z1h-WYHQQzioxrdMcshssH_8rMMswHFXDCAOtOhW0eIZ5_cG9q_kpALlMsqUsnPVD_5_X0NOILk6kePNzj3wDmIlOORS8_pViD5kcrs-oZ55VKQt1fSsDDKzyFDqtsExfPPSO8xjsW7X6Of2z7uoUcU4LpOZBjSpNSZpASVuEb-_NvYpPycyWiviTu3dhpiXe2zl8brF1rwc4dK80D2qVq82ZsGBfARA1nhphBA4c0_sJXUtn6QxTmcPBjowrEKj1VpKLGfFolhhzCksClhIEn7pcWyBBC3_wvtRjzt91JqA-kHHo0-mhstt3spOyx98YyDEawtj2t-K4rpRAhPWR";

    this.flightService
      .bookTeeTimeSlot(reqBookSlot, _addBookingPlayer, this.captchaResponse)
      .subscribe((data: any) => {
        if (data) {
          let _message = `Thank you for booking with myGolf2u.<br> Please see 'My Bookings' for details.<br>
      Before making payment you will need to add players and complete all mandatory options.`;
          if (data != '' && data != undefined && data != null) {
            let alert = this.alertCtrl
              .create({
                header: 'Booking In Process',

                message: _message,
                buttons: [
                  {
                    text: 'Close',
                  },
                  {
                    text: 'Go to My Bookings',
                    handler: () => {
                      this.setBookingType(2);
                      this.togglePanel(1, true);
                    },
                  },
                ],
              })
              .then(res => {
                res.present();
              });
          }
        }
      });
  }

  togglePanel(panel: number, fromQuickBook?: boolean) {
    //  this.toggleActivePanel = false;
    // this.togglePastPanel = false;
    // this.toggleCancelPanel = false;
    // this.toggleInvitedPanel = false;
    if (panel === 1) {
      this.togglePastPanel = false;
      this.toggleCancelPanel = false;
      this.toggleInvitedPanel = false;
      this.toggleActivePanel = true;
      // else this.toggleActivePanel = !this.toggleActivePanel;
    } else if (panel === 2) {
      this.toggleActivePanel = false;
      this.togglePastPanel = true;
      this.toggleCancelPanel = false;
      this.toggleInvitedPanel = false;
      // this.togglePastPanel = true;
    } else if (panel === 3) {
      this.toggleActivePanel = false;
      this.togglePastPanel = false;
      this.toggleCancelPanel = true;
      this.toggleInvitedPanel = false;
      // this.toggleCancelPanel = true;
    } else if (panel === 4) {
      this.toggleActivePanel = false;
      this.togglePastPanel = false;
      this.toggleCancelPanel = false;
      this.toggleInvitedPanel = true;
      // this.toggleInvitedPanel = true;
    }
    this.refreshBookingHome();
  }

  public refreshOnViewEntered(refresh: boolean) {
    this.refreshOnEnter = refresh;
  }

  public refreshPage(pushData: any) {
    this._refreshValues(null, null);
  }

  public getNotifications(): Array<NotificationHandlerInfo> {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST,
      whenActive: 'showToast',
      whenInactive: 'none',
      needRefresh: true,
    });
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED,
      whenActive: 'showToast',
      whenInactive: 'none',
      needRefresh: true,
    });
    return notifications;
  }
  private _refreshValues(refresher, infinite) {}

  onSearchInput(searchbar) {
    this.refreshBookingHome();
    // this._refreshValues(null, null);
  }

  onSearchCancel() {}

  refreshBookingHome(refresh?: boolean) {
    if (this.togglePastPanel) {
      if (this.useHistorical) this.refreshHistoryBooking();
      else this.refreshPastBooking();
    } else if (this.toggleCancelPanel) {
      if (this.useHistorical) this.refreshHistoryCancelBooking();
      else this.refreshCancelBooking();
    } else if (this.toggleInvitedPanel) this.refreshInvitedBooking();
    else {
      this.newRefreshActiveBooking();
      // this.refreshActiveBooking();
      // this.refreshInvitedBooking();
    }
  }

  checkCurrentMaxBooking() {
    let _playerId;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _playerId = player.playerId;
    });

    let _fromDate = moment().format('YYYY-MM-DD');
    let _startDate = `<b>` + moment(this.startDate).format('dddd, DD MMM YYYY') + `</b>`;

    let _current;
    this.flightService
      .getBookingByPlayer(_playerId, this.startDate)
      .subscribe((bookingByPlayerList: Array<TeeTimeBooking>) => {
        this.loadingCtrl.dismiss().then(async () => {
          this.refresher = false;
          if (bookingByPlayerList.length > 0) {
            // this.bookingByPlayerList = bookingByPlayerList;
            _current = bookingByPlayerList
              .filter((tb: TeeTimeBooking) => {
                return moment(tb.slotAssigned.teeOffDate).format('YYYY-MM-DD') === this.startDate;
              })
              .filter((tb: TeeTimeBooking) => {
                return (
                  tb.bookingStatus === 'Booked' ||
                  tb.bookingStatus === 'PaymentPartial' ||
                  tb.bookingStatus === 'Secured'
                );
              });

            if (0) {
              // _current.length >= this.currentMaxBooking
              let alert = await this.alertCtrl.create({
                header: 'Unpaid booking exceeded',
                // subTitle: 'Selected date is '+ _date,
                message:
                  'You have <b>' +
                  this.playerMaxBooking.maxUnpaidBookings +
                  '</b> unpaid booking(s)' +
                  ', which is the max this club allows. Please pay booking for this date : ' +
                  _startDate, //'Selected date is ' + '<b>' + _date + '</b>',
                buttons: ['Close'],
              });
              alert.present();
            } else if (!this.allowPlayerUnpaidBooking() && this.enableQuickBookCheck()) {
              let alert = await this.alertCtrl.create({
                header: 'Unpaid booking exceeded',
                // subTitle: 'Selected date is '+ _date,
                message:
                  'You have <b>' +
                  this.playerMaxBooking.maxUnpaidBookings +
                  '</b> unpaid booking(s)' +
                  ', which is the max this club allows. Please pay booking for this date : ' +
                  _startDate, //'Selected date is ' + '<b>' + _date + '</b>',
                buttons: ['Close'],
              });
              alert.present();
            } else if (!this.allowPlayerMaxBookingsPerDay() && this.enableQuickBookCheck()) {
              let alert = await this.alertCtrl.create({
                header: 'Max booking per day exceeded',
                // subTitle: 'Selected date is '+ _date,
                message:
                  'You already have <b>' +
                  this.bookingOptions.maxBookingsPerDay +
                  '</b> booking(s) for this date : ' +
                  _startDate +
                  ', which is the max this club allows', //'Selected date is ' + '<b>' + _date + '</b>',
                buttons: ['Close'],
              });
              alert.present();
            } else this.onBookNow();
          } else if (!this.allowPlayerUnpaidBooking() && this.enableQuickBookCheck()) {
            let alert = await this.alertCtrl.create({
              header: 'Unpaid booking exceeded',
              // subTitle: 'Selected date is '+ _date,
              message:
                'You have <b>' +
                this.playerMaxBooking.maxUnpaidBookings +
                '</b> unpaid booking(s)' +
                ', which is the max this club allows. Please pay booking for this date : ' +
                _startDate +
                ', which is the max this club allows', //'Selected date is ' + '<b>' + _date + '</b>',
              buttons: ['Close'],
            });
            alert.present();
          } else if (!this.allowPlayerMaxBookingsPerDay() && this.enableQuickBookCheck()) {
            let alert = await this.alertCtrl.create({
              header: 'Max booking per day exceeded',
              // subTitle: 'Selected date is '+ _date,
              message:
                'You already have <b>' +
                this.bookingOptions.maxBookingsPerDay +
                '</b> booking(s) for this date : ' +
                _startDate +
                ', which is the max this club allows', //'Selected date is ' + '<b>' + _date + '</b>',
              buttons: ['Close'],
            });
            alert.present();
          } else this.onBookNow();
        });
      });
  }
  enableQuickBookCheck() {
    if (this.appAttribute && this.appAttribute.enableQuickbookCheck) return true;
    else return false;
  }
  checkClubQuickbookSlot() {}
  allowPlayerUnpaidBooking() {
    if (!this.playerMaxBooking) return true;
    else if (this.playerMaxBooking.totalBookings === 0) return true;
    else return this.playerMaxBooking.totalUnpaidBookings < this.playerMaxBooking.maxUnpaidBookings;
  }
  allowPlayerMaxBookingsPerDay() {
    if (!this.playerMaxBooking) return true;
    else if (this.playerMaxBooking.totalBookings === 0) return true;
    if (this.bookingOptions.maxBookingsPerDay === 0) return true;
    else return this.playerMaxBooking.totalBookings < this.bookingOptions.maxBookingsPerDay;
  }

  subBookingSearchPlayer: Subscription;

  async refreshBookingForPlayer(pageNo?: number) {
    this.refresherPast = true;
    this.pastBookingByPlayerList = [];

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    // this.playerHomeInfo$      = this.playerHomeService.playerHomeInfo();
    // this.player$.take(1).subscribe((player: PlayerInfo) => {
    //     _playerId = player.playerId
    // });

    // subtract(7,'days').
    let _fromDate;
    let _toDate;
    // if (this.historyMonthly) {
    //   _fromDate = moment(this.histPastDate)
    //     .startOf('month')
    //     .format('YYYY-MM-DD');
    //   if (
    //     moment(this.histPastDate).format('YYYY-MM') ===
    //     moment().format('YYYY-MM')
    //   ) {
    //     _toDate = moment().add(-1, 'days').format('YYYY-MM-DD');
    //   } else
    //     _toDate = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
    // } else if (!this.historyMonthly) {
    //   _fromDate = moment(this.histStartDate).format('YYYY-MM-DD');
    //   _toDate = moment(this.histEndDate).format('YYYY-MM-DD');
    // }

    this.activeDateSince = _fromDate;

    let _clubId = null;
    if (this.clubInfo && this.clubInfo.clubId) _clubId = this.clubInfo.clubId;
    let _statusType = 'A'; //(A)ctive, (I)nactive, (B)oth
    let _statusList: Array<string> = [];
    let _courseId = null;
    let _search = '';
    if (this.searchQuery && this.searchQuery.length > 0)
      _search = this.searchQuery.toLowerCase().trim();
    let _pageSize = null;
    let _pageNo = null;
    let _descendingDate = true;
    if (pageNo) _pageNo = pageNo;
    this.flightService
      .searchBookingPlayer(
        _playerId,
        _clubId,
        _fromDate,
        _toDate,
        _statusType,
        _statusList,
        _courseId,
        _search,
        _pageSize,
        _pageNo,
        _descendingDate
      )
      .subscribe(
        (dataPlayerBookingList: PagedData<TeeTimeBooking>) => {
          this.historyPlayerBookingList = dataPlayerBookingList;
          this.historyCurrentPage = dataPlayerBookingList.currentPage;
          this.historyTotalPages = dataPlayerBookingList.totalPages;
          this.historyTotalItems = dataPlayerBookingList.totalItems;
          this.historyPageSize = dataPlayerBookingList.totalInPage;
          let pastBookingByPlayerList: Array<TeeTimeBooking> = dataPlayerBookingList.items;
          loader.dismiss().then(() => {
            if (pastBookingByPlayerList.length > 0) {
              this.pastBookingByPlayerList = pastBookingByPlayerList;

              let _pastBookings;
              this.pastBookingByPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? 1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? -1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
                }
                // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
                //     return 1;
                // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
                //     return -1;
                // else 0;
              });
              let _today = moment().format('YYYY-MM-DD');
              // this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter((tb: TeeTimeBooking)=>{
              //     // "Secured" | "CancelledByPlayer" | "CancelledByClub" | "PaymentPartial" | "PaymentFull" | "FlightRegistered"
              //     return tb.bookingStatus !== 'CancelledByPlayer' && tb.bookingStatus !== 'CancelledByClub'
              // })

              this.pastBookingByPlayerList = this.pastBookingByPlayerList
                .filter(t => {
                  return (
                    moment(t.slotAssigned.teeOffDate, 'YYYY-MM-DD').format('YYYY-MM-DD') <= _today
                  );
                })
                .map(t => {
                  return t;
                });

              this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  let _hasPlayer = tb.bookingPlayers.filter(p => {
                    if (p.player) return p.player.id === _playerId && !p.playerRemoved;
                  });
                  if (_hasPlayer && _hasPlayer.length > 0) return true;
                  else return false;
                }
              );

              // _pastBookings.forEach((t)=>{

              // })
            }
            this.refresherPast = false;
          });
        },
        error => {
          this.loadingCtrl.dismiss();
          this.refresherPast = false;
        }
      );
  }

  // refreshBookingForPlayer() {
  //   if(this.subBookingSearchPlayer) return;

  //   this.flight
  // }
  async refreshActiveBooking() {
    if (this.subBookingByPlayer) return;

    this.refresher = true;
    this.bookingByPlayerList = [];
    let _playerId;
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    // subtract(7,'days').
    let _fromDate = moment().format('YYYY-MM-DD'); //moment(this.startDate).format("YYYY-MM-DD");
    this.activeDateSince = _fromDate;
    let _clubId;
    if (this.isClubSpecific && this.clubInfo && this.clubInfo.clubId)
      _clubId = this.clubInfo.clubId;
    this.subBookingByPlayer = this.flightService
      .getBookingByPlayer(_playerId, _fromDate, 999, _clubId)
      .subscribe(
        (bookingByPlayerList: Array<TeeTimeBooking>) => {
          loader.dismiss().then(() => {
            if (bookingByPlayerList.length > 0) {
              bookingByPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? -1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? 1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? -1 : 1;
                }

                // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
                //     return -1;
                // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
                //     return 1;
                // else 0;
              });

              this.bookingByPlayerList = bookingByPlayerList.filter((tb: TeeTimeBooking) => {
                return (
                  tb.bookingStatus === 'Booked' ||
                  tb.bookingStatus === 'PaymentPartial' ||
                  tb.bookingStatus === 'Secured' ||
                  tb.bookingStatus === 'PaymentFull'
                );
              });

              if (this.searchQuery && this.searchQuery.length > 0)
                this.bookingByPlayerList = this.bookingByPlayerList.filter((tb: TeeTimeBooking) => {
                  return (
                    tb.clubData &&
                    (tb.clubData.name.toLowerCase().includes(this.searchQuery.trim()) ||
                      tb.clubData.tag.toLowerCase().includes(this.searchQuery.trim()))
                  );
                });

              // for(let x = 1; x < 40; x++) {
              //     this.bookingByPlayerList.push(...bookingByPlayerList)
              // }
              // bookingByPlayerList;
            }
          });
          if (this.subBookingByPlayer) {
            this.subBookingByPlayer.unsubscribe();
            this.subBookingByPlayer = null;
          }
          this.refresher = false;
        },
        error => {
          // if(error.status===0) {

          MessageDisplayUtil.showMessageToast(
            'Error connecting to server. Please refresh.',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          // }
          this.errorMessage = 'Error connecting to server. Tap here to refresh.';
          loader.dismiss().then(() => {});
          this.refresher = false;
          if (this.subBookingByPlayer) {
            this.subBookingByPlayer.unsubscribe();
            this.subBookingByPlayer = null;
          }
        },
        () => {}
      );
  }

  async refreshInvitedBooking() {
    if (this.subBookingForPlayer) return;
    this.refresherInvited = true;
    this.invitedBookingForPlayerList = [];

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    let _userId;

    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
        _userId = player.userId;
      });
    }

    // subtract(7,'days').
    let _fromDate = moment().format('YYYY-MM-DD'); //moment(this.startDate).format("YYYY-MM-DD");
    this.activeDateSince = _fromDate;

    // this.flightService.getBookingForPlayer(_playerId, _fromDate)

    let _clubId;
    if (this.clubInfo && this.clubInfo.clubId) _clubId = this.clubInfo.clubId;
    this.subBookingForPlayer = this.flightService
      .getBookingForPlayer(_playerId, _fromDate, null, _clubId)
      .subscribe(
        (invitedBookingForPlayerList: Array<TeeTimeBooking>) => {
          loader.dismiss().then(() => {
            if (invitedBookingForPlayerList.length > 0) {
              invitedBookingForPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? -1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? 1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? -1 : 1;
                }

                // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
                //     return -1;
                // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
                //     return 1;
                // else 0;
              });

              this.invitedBookingForPlayerList = invitedBookingForPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  return (
                    (tb.bookingStatus === 'Booked' ||
                      tb.bookingStatus === 'PaymentPartial' ||
                      tb.bookingStatus === 'Secured' ||
                      tb.bookingStatus === 'PaymentFull') &&
                    ((tb.bookedByPlayer && tb.bookedByPlayer.id !== _playerId) || tb.bookedByUser)
                  );
                }
              );

              this.invitedBookingForPlayerList = this.invitedBookingForPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  let _hasPlayer = tb.bookingPlayers.filter(p => {
                    if (p.player) return p.player.id === _playerId && !p.playerRemoved;
                  });
                  if (_hasPlayer && _hasPlayer.length > 0) return true;
                  else return false;
                }
              );

              if (this.searchQuery && this.searchQuery.length > 0)
                this.invitedBookingForPlayerList = this.invitedBookingForPlayerList.filter(
                  (tb: TeeTimeBooking) => {
                    return (
                      tb.clubData &&
                      (tb.clubData.name.toLowerCase().includes(this.searchQuery.trim()) ||
                        tb.clubData.tag.toLowerCase().includes(this.searchQuery.trim()))
                    );
                  }
                );
              // bookingByPlayerList;
            }
            if (this.subBookingForPlayer) {
              this.subBookingForPlayer.unsubscribe();
              this.subBookingForPlayer = null;
            }
            this.refresherInvited = false;
          });
        },
        error => {
          // if(error.status===0) {

          MessageDisplayUtil.showMessageToast(
            'Error connecting to server. Please refresh.',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          // }
          this.errorMessage = 'Error connecting to server. Tap here to refresh.';
          loader.dismiss();
          this.refresherInvited = false;

          if (this.subBookingForPlayer) {
            this.subBookingForPlayer.unsubscribe();
            this.subBookingForPlayer = null;
          }
        },
        () => {}
      );
  }

  async refreshHistoryBooking(pageNo?: number) {
    this.refresherPast = true;
    this.pastBookingByPlayerList = [];

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    // this.playerHomeInfo$      = this.playerHomeService.playerHomeInfo();
    // this.player$.take(1).subscribe((player: PlayerInfo) => {
    //     _playerId = player.playerId
    // });

    // subtract(7,'days').
    let _fromDate;
    let _toDate;
    if (this.historyMonthly) {
      _fromDate = moment(this.histPastDate).startOf('month').format('YYYY-MM-DD');
      if (moment(this.histPastDate).format('YYYY-MM') === moment().format('YYYY-MM')) {
        _toDate = moment().add(-1, 'days').format('YYYY-MM-DD');
      } else _toDate = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
    } else if (!this.historyMonthly) {
      _fromDate = moment(this.histStartDate).format('YYYY-MM-DD');
      _toDate = moment(this.histEndDate).format('YYYY-MM-DD');
    }

    this.activeDateSince = _fromDate;

    let _clubId = null;
    if (this.clubInfo && this.clubInfo.clubId) _clubId = this.clubInfo.clubId;
    let _statusType = 'A'; //(A)ctive, (I)nactive, (B)oth
    let _statusList: Array<string> = [];
    let _courseId = null;
    let _search = '';
    if (this.searchQuery && this.searchQuery.length > 0)
      _search = this.searchQuery.toLowerCase().trim();
    let _pageSize = null;
    let _pageNo = null;
    let _descendingDate = true;
    if (pageNo) _pageNo = pageNo;
    this.flightService
      .searchBookingPlayer(
        _playerId,
        _clubId,
        _fromDate,
        _toDate,
        _statusType,
        _statusList,
        _courseId,
        _search,
        _pageSize,
        _pageNo,
        _descendingDate
      )
      .subscribe(
        (dataPlayerBookingList: PagedData<TeeTimeBooking>) => {
          this.historyPlayerBookingList = dataPlayerBookingList;
          this.historyCurrentPage = dataPlayerBookingList.currentPage;
          this.historyTotalPages = dataPlayerBookingList.totalPages;
          this.historyTotalItems = dataPlayerBookingList.totalItems;
          this.historyPageSize = dataPlayerBookingList.totalInPage;
          let pastBookingByPlayerList: Array<TeeTimeBooking> = dataPlayerBookingList.items;
          loader.dismiss().then(() => {
            if (pastBookingByPlayerList.length > 0) {
              this.pastBookingByPlayerList = pastBookingByPlayerList;

              let _pastBookings;
              this.pastBookingByPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? 1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? -1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
                }
                // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
                //     return 1;
                // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
                //     return -1;
                // else 0;
              });
              let _today = moment().format('YYYY-MM-DD');
              // this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter((tb: TeeTimeBooking)=>{
              //     // "Secured" | "CancelledByPlayer" | "CancelledByClub" | "PaymentPartial" | "PaymentFull" | "FlightRegistered"
              //     return tb.bookingStatus !== 'CancelledByPlayer' && tb.bookingStatus !== 'CancelledByClub'
              // })

              this.pastBookingByPlayerList = this.pastBookingByPlayerList
                .filter(t => {
                  return (
                    moment(t.slotAssigned.teeOffDate, 'YYYY-MM-DD').format('YYYY-MM-DD') <= _today
                  );
                })
                .map(t => {
                  return t;
                });

              this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  let _hasPlayer = tb.bookingPlayers.filter(p => {
                    if (p.player) return p.player.id === _playerId && !p.playerRemoved;
                  });
                  if (_hasPlayer && _hasPlayer.length > 0) return true;
                  else return false;
                }
              );

              // _pastBookings.forEach((t)=>{

              // })
            }
            this.refresherPast = false;
          });
        },
        error => {
          this.loadingCtrl.dismiss();
          this.refresherPast = false;
        }
      );
  }

  async refreshPastBooking() {
    this.refresherPast = true;
    this.pastBookingByPlayerList = [];

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    // subtract(7,'days').
    let _fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD'); //moment(this.startDate).format("YYYY-MM-DD");
    this.activeDateSince = _fromDate;

    let _clubId;
    if (this.isClubSpecific && this.clubInfo && this.clubInfo.clubId)
      _clubId = this.clubInfo.clubId;
    this.flightService.getBookingByPlayer(_playerId, _fromDate, _clubId).subscribe(
      (pastBookingByPlayerList: Array<TeeTimeBooking>) => {
        loader.dismiss().then(() => {
          if (pastBookingByPlayerList.length > 0) {
            this.pastBookingByPlayerList = pastBookingByPlayerList;

            let _pastBookings;
            this.pastBookingByPlayerList.sort((a, b) => {
              if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                  ? 1
                  : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                    ? -1
                    : 0;
              } else {
                return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
              }
              // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
              //     return 1;
              // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
              //     return -1;
              // else 0;
            });
            let _today = moment().format('YYYY-MM-DD');
            this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter(
              (tb: TeeTimeBooking) => {
                // "Secured" | "CancelledByPlayer" | "CancelledByClub" | "PaymentPartial" | "PaymentFull" | "FlightRegistered"
                return (
                  tb.bookingStatus !== 'CancelledByPlayer' && tb.bookingStatus !== 'CancelledByClub'
                );
              }
            );

            this.pastBookingByPlayerList = this.pastBookingByPlayerList
              .filter(t => {
                return (
                  moment(t.slotAssigned.teeOffDate, 'YYYY-MM-DD').format('YYYY-MM-DD') < _today
                );
              })
              .map(t => {
                return t;
              });

            this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter(
              (tb: TeeTimeBooking) => {
                let _hasPlayer = tb.bookingPlayers.filter(p => {
                  if (p.player) return p.player.id === _playerId && !p.playerRemoved;
                });
                if (_hasPlayer && _hasPlayer.length > 0) return true;
                else return false;
              }
            );

            if (this.searchQuery && this.searchQuery.length > 0)
              this.pastBookingByPlayerList = this.pastBookingByPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  return (
                    tb.clubData &&
                    (tb.clubData.name.toLowerCase().includes(this.searchQuery.trim()) ||
                      tb.clubData.tag.toLowerCase().includes(this.searchQuery.trim()))
                  );
                }
              );

            // _pastBookings.forEach((t)=>{

            // })
          }
          this.refresherPast = false;
        });
      },
      error => {
        loader.dismiss();
        this.refresherPast = false;
      }
    );
  }

  async refreshHistoryCancelBooking(pageNo?: number) {
    this.refresherCancel = true;
    this.cancelledBookingByPlayerList = [];
    let self = this;
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    let _fromDate;
    let _toDate;
    if (this.cancelMonthly) {
      _fromDate = moment(this.cancelPastDate).startOf('month').format('YYYY-MM-DD');

      _toDate = moment(this.cancelPastDate).endOf('month').format('YYYY-MM-DD');
    } else if (!this.cancelMonthly) {
      _fromDate = this.cancelStartDate;
      _toDate = this.cancelEndDate;
    }

    this.activeDateSince = _fromDate;

    let _clubId = null;
    if (this.isClubSpecific && this.clubInfo && this.clubInfo.clubId)
      _clubId = this.clubInfo.clubId;
    let _statusType = 'I';
    let _statusList: Array<string> = [];
    let _courseId = null;
    let _search = '';
    if (this.searchQuery && this.searchQuery.length > 0)
      _search = this.searchQuery.toLowerCase().trim();
    let _pageSize = null;
    let _pageNo = null;
    let _descendingDate = true;
    if (pageNo) _pageNo = pageNo;
    this.flightService
      .searchBookingPlayer(
        _playerId,
        _clubId,
        _fromDate,
        _toDate,
        _statusType,
        _statusList,
        _courseId,
        _search,
        _pageSize,
        _pageNo,
        _descendingDate
      )
      .subscribe(
        (dataPlayerBookingList: PagedData<TeeTimeBooking>) => {
          this.cancelPlayerBookingList = dataPlayerBookingList;
          this.cancelCurrentPage = dataPlayerBookingList.currentPage;
          this.cancelTotalPages = dataPlayerBookingList.totalPages;
          this.cancelTotalItems = dataPlayerBookingList.totalItems;
          this.cancelPageSize = dataPlayerBookingList.totalInPage;
          let cancelledBookingByPlayerList: Array<TeeTimeBooking> = dataPlayerBookingList.items;
          loader.dismiss().then(() => {
            if (cancelledBookingByPlayerList.length > 0) {
              this.cancelledBookingByPlayerList = cancelledBookingByPlayerList;
              let _cancelBookings;
              this.cancelledBookingByPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? 1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? -1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
                }
              });
              let _today = moment().format('YYYY-MM-DD');
            }
            this.refresherCancel = false;
          });
        },
        error => {
          this.loadingCtrl.dismiss();
          this.refresherCancel = false;
        }
      );
  }

  async refreshCancelBooking() {
    this.refresherCancel = true;
    this.cancelledBookingByPlayerList = [];

    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;

    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    }

    // this.player$.take(1).subscribe((player: PlayerInfo) => {
    //     _playerId = player.playerId
    // });

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _playerId = player.playerId;
    });

    // subtract(7,'days').
    let _fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD'); //moment(this.startDate).format("YYYY-MM-DD");
    this.activeDateSince = _fromDate;

    let _clubId;
    if (this.isClubSpecific && this.clubInfo && this.clubInfo.clubId)
      _clubId = this.clubInfo.clubId;
    this.flightService.getBookingByPlayer(_playerId, _fromDate, null, _clubId).subscribe(
      (cancelledBookingByPlayerList: Array<TeeTimeBooking>) => {
        loader.dismiss().then(() => {
          if (cancelledBookingByPlayerList.length > 0) {
            // this.cancelledBookingByPlayerList =
            cancelledBookingByPlayerList;

            let _cancelBookings;
            cancelledBookingByPlayerList.sort((a, b) => {
              if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                  ? 1
                  : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                    ? -1
                    : 0;
              } else {
                return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
              }
              // if(a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate)
              //     return 1;
              // else if(a.slotAssigned.teeOffDate > b.slotAssigned.teeOffDate)
              //     return -1;
              // else 0;
            });
            // let _today = moment().format('YYYY-MM-DD');

            this.cancelledBookingByPlayerList = cancelledBookingByPlayerList
              .filter((tb: TeeTimeBooking) => {
                // "Secured" | "CancelledByPlayer" | "CancelledByClub" | "PaymentPartial" | "PaymentFull" | "FlightRegistered"
                return (
                  tb.bookingStatus === 'CancelledByPlayer' || tb.bookingStatus === 'CancelledByClub'
                );
              })
              // .filter((t)=>{

              //     return moment(t.slotAssigned.teeOffDate,'YYYY-MM-DD').format('YYYY-MM-DD') <= _today;
              // })
              .map(t => {
                return t;
              });

            this.cancelledBookingByPlayerList = this.cancelledBookingByPlayerList.filter(
              (tb: TeeTimeBooking) => {
                let _hasPlayer = tb.bookingPlayers.filter(p => {
                  if (p.player) return p.player.id === _playerId && !p.playerRemoved;
                });
                if (_hasPlayer && _hasPlayer.length > 0) return true;
                else return false;
              }
            );
            if (this.searchQuery && this.searchQuery.length > 0)
              this.cancelledBookingByPlayerList = this.cancelledBookingByPlayerList.filter(
                (tb: TeeTimeBooking) => {
                  return (
                    tb.clubData &&
                    (tb.clubData.name.toLowerCase().includes(this.searchQuery.trim()) ||
                      tb.clubData.tag.toLowerCase().includes(this.searchQuery.trim()))
                  );
                }
              );

            // this.cancelledBookingByPlayerList = this.cancelledBookingByPlayerList

            // _pastBookings.forEach((t)=>{

            // })
          }
          this.refresherCancel = false;
        });
      },
      error => {
        loader.dismiss();
        this.refresherCancel = false;
      }
    );
  }

  onMoreFilter() {
    this.router.navigate(['booking-search']);
  }

  // navigate(){
  //   this.router.navigate(["/tabs/player-home"]);
  // }

  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    if (this.captchaResponse.length > 0) this.goQuickBook();
  }

  onTooltipRecaptcha() {
    let _message =
      'This ensures that computers / robots are unable to access our system and conduct block bookings.';
    let alert: any = this.alertCtrl.create({
      header: 'Recaptcha Verification',
      // subTitle: 'Selected date is '+ _date,
      message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
      buttons: ['Close'],
    });
    alert.present();
  }

  getBookingDetails(x: TeeTimeBooking, attribute?: string) {
    let _bookingDetails = x;
    let _slot = _bookingDetails.slotAssigned;

    switch (attribute) {
      case 'date':
        return moment(_slot.teeOffDate).format('ddd, DD MMM YYYY');
      case 'time':
        return moment(_slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
      case 'bookingBy':
        if (_bookingDetails.bookingAgent) return '[' + _bookingDetails.bookingAgent.name + '] ';
        else if (_bookingDetails.bookedByUser && !_bookingDetails.bookedByPlayer) return '[Club]';
        else if (_bookingDetails.bookedByUser && _bookingDetails.bookedByPlayer) {
          if (_bookingDetails.bookedByUser.id !== _bookingDetails.bookedByPlayer.userId)
            return '[Club]';
          else return _bookingDetails.bookedByPlayer.firstName;
        } else return '';
      // if (_bookingDetails.bookedByPlayer)
      //   return _bookingDetails.bookedByPlayer.firstName;
      // else return '[Club]';
      case 'reference':
        return '#' + _bookingDetails.bookingReference;
      case 'clubName':
        return _bookingDetails.clubData.name;
      case 'clubImage':
        // console.debug("club image ", _bookingDetails.clubData);
        // if(_bookingDetails?.clubData?.clubLogo)
        //   return _bookingDetails.clubData.clubLogo;
        if (_bookingDetails?.clubData?.clubThumbnail) return _bookingDetails.clubData.clubThumbnail;
        else if (_bookingDetails?.clubData?.clubImage) return _bookingDetails.clubData.clubImage;
        else return _bookingDetails.clubData.clubLogo;
      case 'courseName':
        return _bookingDetails.slotAssigned.startCourse.name;
      case 'playerCount':
        let _removedPlayers;
        if (_bookingDetails.bookingPlayers)
          _removedPlayers = _bookingDetails.bookingPlayers.filter(p => {
            return p.playerRemoved;
          });
        return _bookingDetails.bookingPlayers
          ? _bookingDetails.bookingPlayers.length - _removedPlayers.length
          : '';
      // '('+_bookingDetails.bookingPlayers.length+')'
      case 'currency':
        return _bookingDetails.slotAssigned.currency.symbol;
      case 'amountPayable':
        let _total = Number(
          (_bookingDetails.amountPayable - _bookingDetails.totalDeductions).toFixed(2)
        );
        return this.getCurrencyAmount(_total);
      // let _total = Number(
      //   (
      //     _bookingDetails.amountPayable - _bookingDetails.totalDeductions
      //   ).toFixed(2)
      // );

      // let _amount = String(_total);
      // let _amtTxt;
      // if (
      //   _total <= 999999 &&
      //   String(_total).split('.')[1] &&
      //   String(_total).split('.')[1].length < 2
      // )
      //   _amtTxt = this.numberWithCommas(_total) + '0';
      // else if (_total > 999999)
      //   _amtTxt = this.numberWithCommas(_amount.split('.')[0]);
      // else _amtTxt = this.numberWithCommas(_total);
      // // if(_bookingDetails.amountPayable > 999999)
      // //     _amtTxt =  this.numberWithCommas(_amount.split(".")[0]);
      // // _amtTxt = this.numberWithCommas(_bookingDetails.amountPayable);
      // return _amtTxt;
      case 'amountPaid':
        let _paid = Number((_bookingDetails.amountPaid - _bookingDetails.totalRefund).toFixed(2));
        return this.getCurrencyAmount(_paid);
      case 'whichNine':
        let _whichNine = 0;
        if (_bookingDetails.ninesPlayed && _bookingDetails.ninesPlayed > 0)
          _whichNine = _bookingDetails.ninesPlayed * 9;
        return _whichNine;
      case 'bookingStatus':
        return this.getFlightStatus(_bookingDetails);
    }
  }

  getBookingAmountInNumber(x: TeeTimeBooking, type: string) {
    let _bookingDetails = x;
    switch (type) {
      case 'amountPayable':
        return Number((_bookingDetails.amountPayable - _bookingDetails.totalDeductions).toFixed(2));
      case 'amountPaid':
        return Number((_bookingDetails.amountPaid - _bookingDetails.totalRefund).toFixed(2));
    }
  }

  getCurrencyAmount(value: number) {
    let _total = Number(value.toFixed(2));
    let _amount = String(_total);
    let _amtTxt;
    if (_total <= 999999 && String(_total).split('.')[1] && String(_total).split('.')[1].length < 2)
      _amtTxt = this.numberWithCommas(_total) + '0';
    else if (_total > 999999) _amtTxt = this.numberWithCommas(_amount.split('.')[0]);
    else _amtTxt = this.numberWithCommas(_total);
    return _amtTxt;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  getActiveBookingDetails(attribute?: string) {
    switch (attribute) {
      case 'date':
        return '&nbsp;* since ' + moment(this.activeDateSince).format('ddd, DD MMM YYYY');
    }
  }

  moreSlots(type?: string) {
    if (type === 'active' || !type) {
      this.toggleSlots = !this.toggleSlots;
      this.togglePastSlots = false;
      this.toggleCancelSlots = false;
      this.toggleInvitedSlots = false;
    } else if (type === 'past') {
      this.toggleSlots = false;
      this.toggleCancelSlots = false;
      this.togglePastSlots = !this.togglePastSlots;
      this.toggleInvitedSlots = false;
    } else if (type === 'cancel') {
      this.toggleSlots = false;
      this.togglePastSlots = false;
      this.toggleCancelSlots = !this.toggleCancelSlots;
      this.toggleInvitedSlots = false;
    } else if (type === 'invited') {
      this.toggleSlots = false;
      this.togglePastSlots = false;
      this.toggleCancelSlots = false;
      this.toggleInvitedSlots = !this.toggleInvitedSlots;
    }
  }
  checkClubBookingOption() {
    let _playerId;
    let _playerMaxBooking: BookingCount;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _playerId = player.playerId;
    });
    this.flightService
      .getClubBookingOptions(this.clubInfo.clubId, this.startDate)
      .subscribe((bookOpts: TeeTimeBookingOptions) => {
        if (bookOpts) {
          this.bookingOptions = bookOpts;
          this.currentMaxBooking = bookOpts.maxUnpaidBookings;
          this.flightService
            .getPlayerMaxBooking(this.clubInfo.clubId, _playerId, this.startDate)
            .subscribe(data => {
              if (data) {
                this.playerMaxBooking = data;
                this.checkCurrentMaxBooking();
              } else this.checkCurrentMaxBooking();
            });
        }
      });

    // this.onBookNow()
  }
  nextDate(type?: string) {
    let _pastMonth = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
    let _cancelMonth = moment(this.cancelPastDate).endOf('month').format('YYYY-MM-DD');

    if (type === 'past')
      this.histPastDate = moment(this.histPastDate).add(1, 'month').format('YYYY-MM-DD');
    if (type === 'cancel')
      this.cancelPastDate = moment(this.cancelPastDate).add(1, 'month').format('YYYY-MM-DD');
    if (type === 'active')
      this.activeDate = moment(this.activeDate).add(1, 'month').format('YYYY-MM-DD');
    else this.currentDate = moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD');
  }

  prevDate(type?: string) {
    if (type === 'past')
      this.histPastDate = moment(this.histPastDate).subtract(1, 'month').format('YYYY-MM-DD');
    else if (type === 'cancel')
      this.cancelPastDate = moment(this.cancelPastDate).subtract(1, 'month').format('YYYY-MM-DD');
    else if (type === 'active')
      this.activeDate = moment(this.activeDate).subtract(1, 'month').format('YYYY-MM-DD');
    else this.currentDate = moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD');
  }

  confirmDate(type?: string) {
    if (type === 'today') {
    } else if (type === 'future') {
    } else if (type === 'past') {
      if (this.useHistorical) this.refreshHistoryBooking();
      else this.refreshPastBooking();
    } else if (type === 'cancel') {
      if (this.useHistorical) this.refreshHistoryCancelBooking();
      else this.refreshCancelBooking();
    } else if (type === 'active') {
      this.newRefreshActiveBooking();
    }
  }

  prevPage(type?: string) {
    if (type === 'active') {
      let _activeMonth = moment(this.activeDate).endOf('month').format('YYYY-MM-DD');
      if (moment(_activeMonth).isSameOrBefore(moment(this.activePrevMonth).endOf('month'), 'month'))
        return false;
      else return true;
    } else return true;
  }

  nextPage(type?: string) {
    if (type === 'cancel') {
      let _cancelMonth = moment(this.cancelPastDate).endOf('month').format('YYYY-MM-DD');
      if (moment(_cancelMonth).isSameOrAfter(moment(this.cancelNextMonth).endOf('month'), 'month'))
        return false;
      else return true;
    } else {
      let _pastMonth = moment(this.histPastDate).endOf('month').format('YYYY-MM-DD');
      if (moment(_pastMonth).isSameOrAfter(moment(this.histNextMonth).endOf('month'), 'month'))
        return false;
      else return true;
    }
  }

  prevHistPage() {
    if (this.historyCurrentPage === 1) return;
    let _currPage = this.historyCurrentPage;
    this.refreshHistoryBooking(_currPage - 1);
  }

  nextHistPage() {
    if (this.historyCurrentPage >= this.historyTotalPages) return;
    let _currPage = this.historyCurrentPage;
    this.refreshHistoryBooking(_currPage + 1);
  }

  prevCancelPage() {
    if (this.cancelCurrentPage === 1) return;
    let _currPage = this.cancelCurrentPage;
    this.refreshHistoryCancelBooking(_currPage - 1);
  }

  nextCancelPage() {
    if (this.cancelCurrentPage >= this.cancelTotalPages) return;
    let _currPage = this.cancelCurrentPage;
    this.refreshHistoryCancelBooking(_currPage + 1);
  }

  getHistoryPageNumber(count: number) {
    if (!this.historyTotalPages) return;
    if (!this.historyCurrentPage) return;
    return this.historyCurrentPage + count;
  }
  getCancelPageNumber(count: number) {
    if (!this.cancelTotalPages) return;
    if (!this.cancelCurrentPage) return;
    return this.cancelCurrentPage + count;
  }
  backRouting() {
    let _params: NavigationExtras = {
      replaceUrl: false,
    };
    this.router.navigate(['tabs/player-home'], _params);
    // this.location.back();
  }
  getClubSpecific(attribute) {
    return this.mg2uUtil.getClubSpecificHeader(attribute);
  }
  getCountryInfo() {
    if (!this.filterCountry) return 'All Countries';
    else return this.filterCountry && this.filterCountry.name;
  }
  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '')
      return '../../../../assets/img/flag/default_worldwide.png';
    else {
      let flagIcon = flagUrl.split('/');
      return '../../../../assets/img/flag/' + flagIcon[2];
    }
  }
  async onSelectCountry(type?: string) {
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: 'Select Country',
        excludeAll: false,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      let _country: Country = country.data;
      if (!country || country === -999) this.filterCountry = null;
      else this.filterCountry = _country;

      this.clearClubSelection();
    });
    modal.present();
  }
  getColorBookingStatus(teeTimeBooking: TeeTimeBooking) {
    if (!teeTimeBooking) return '';
    let _color = '';
    _color = this.mg2uUtil.getColorBookingStatus(teeTimeBooking.bookingStatus);

    return _color.toLowerCase(); // + ' !important;';
  }
  async getCountry(cb?) {
    (this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    }),
      error => {
        loader.dismiss();
      },
      () => {
        loader.dismiss();
      });

    if (1) return;
    let loader = await this.loadingCtrl.create({
      message: 'Getting Country List...',
      showBackdrop: false,
    });
    loader.present().then(() => {
      (this.playerService.getCountryList().subscribe((data: Array<Country>) => {
        loader.dismiss().then(() => {
          this.countryList = data;
        });
      }),
        error => {
          loader.dismiss();
        },
        () => {
          loader.dismiss();
        });
    });
  }
  onClubPicklist() {
    return new Promise(async (resolve, reject) => {
      let clubId;
      let club = await this.modalCtl.create({
        component: ClubListPage,
        componentProps: {
          countryId: this.filterCountry ? this.filterCountry.id : null,
          openedModal: true,
        },
      });

      club.onDidDismiss().then((data: any) => {
        if (data) {
          clubId = data.data.clubId;
          // this.getClubSession(data.clubId);
        }
        // else {
        //     this.onClubPicklist();
        // }
        if (!clubId) {
          reject({
            status: 'failed',
            message: 'No Club Id provided',
          });
        } else if (clubId) {
          this.flightService.getClubInfo(clubId).subscribe((data: ClubInfo) => {
            if (data) {
              resolve({
                status: 'success',
                message: 'club info',
                clubInfo: data,
              });
            }
          });
        }
      });
      club.present();
    });
  }

  captchaRefExcevuted() {}

  async openTeeTimeModal() {
    if (this.toggleCancelPanel || this.togglePastPanel) return;
    if (1) {
      let params: NavigationExtras = {
        state: {
          userType: 'player',
        },
      };
      this.router.navigate(['find-tee-times'], params);
      return;
    }
    console.log('open search tee time [appAttr] : ', this.appAttribute);
    console.log('open search tee time [clubInfo] : ', this.clubInfo);
    const modal = await this.modalCtl.create({
      component: SearchTeeTimeComponent,
      cssClass: 'search-tee-time-modal',
      componentProps: {
        startDate: this.startDate,
        fromTime: this.fromTime,
        toTime: this.toTime,
        filterCountry: this.filterCountry,
        selectClubType: this.selectClubType,
        isClubSpecific: this.isClubSpecific,
        userType: this.userType,
        countryList: this.countryList,
        filteredLocation: this.filteredLocation,
        courseInfo: this.courseInfo,
        courseType: this.courseType,
        searchDistance: this.searchDistance,
        clubInfo: this.clubInfo,
        appAttribute: this.appAttribute,
        geo: this.geo,
        botsOut: this.botsOut,
        captchaResponse: this.captchaResponse,
      },
      mode: 'ios',
    });

    await modal.present();

    modal.onDidDismiss().then(data => {
      if (data?.data) {
        this.startDate = data?.data?.startDate;
        this.fromTime = data?.data?.fromTime;
        this.toTime = data?.data?.toTime;
        this.filterCountry = data?.data?.filterCountry;
        this.selectClubType = data?.data?.selectClubType;
        this.isClubSpecific = data?.data?.isClubSpecific;
        this.filteredLocation = data?.data?.filteredLocation;
        this.courseInfo = data?.data?.courseInfo;
        this.courseType = data?.data?.courseType;
        this.searchDistance = data?.data?.searchDistance;
        this.clubInfo = data?.data?.clubInfo;
        if (data?.data?.mode === 'quickBook') {
          this.goQuickBook();
        } else {
          this.goSearchTeeTimes();
        }
      }
    });
  }

  getFlightStatus(flight: TeeTimeBooking) {
    let _flightStatus = '';
    let _bookingStatus = '';

    let _status = '';

    if (flight) _bookingStatus = flight.bookingStatus;
    if (flight && flight.flight) _flightStatus = flight.flight.status;

    if (_bookingStatus === 'CancelledByPlayer') _status = 'Player Cancelled';
    else if (_bookingStatus === 'CancelledByClub') _status = 'Club Cancelled';
    else if (_bookingStatus === 'PaymentFull' && flight.amountPaid > 0) _status = 'Paid in Full';
    else if (_bookingStatus === 'PaymentFull' && flight.amountPaid === 0)
      _status =
        this.appAttribute && this.appAttribute.bookingStatus.noneToPay
          ? this.appAttribute.bookingStatus.noneToPay
          : 'Nothing to Pay';
    else if (_bookingStatus === 'PaymentPartial') _status = 'Partially Paid';
    else if (_bookingStatus === 'FlightRegistered') _status = 'Flight Registered';
    else if (_bookingStatus === 'RefundInitiated') _status = 'Refund Initiated';
    else if (_bookingStatus === 'RefundCompleted') _status = 'Refund Completed';
    else _status = _bookingStatus;

    if (_flightStatus && _flightStatus.length > 0) _status += ' | ';
    if (_flightStatus === 'PlayStarted') _status += 'Started';
    else if (_flightStatus === 'Dispatched') _status += 'Dispatched';
    else if (_flightStatus === 'CrossedOver') _status += 'Crossed Over';
    else if (_flightStatus === 'PlayFinished') _status += 'Finished';
    else if (_flightStatus === 'Assigned') _status += 'Checked-In';
    else if (_flightStatus && _flightStatus.length > 0) _status += _flightStatus;

    return _status;
  }

  getBookingList() {
    let _filteredList = [];
    _filteredList.push(...this.activeBookingForPlayerList);
    // _filteredList.push(...this.bookingByPlayerList);
    // _filteredList.push(...this.invitedBookingForPlayerList);
    _filteredList.sort((a, b) => {
      if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
        return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
          ? -1
          : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
            ? 1
            : 0;
      } else {
        return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? -1 : 1;
      }
    });
    return this.mg2uUtil.getUnique(_filteredList, 'id');
  }

  goToHome() {
    this.mg2uUtil.goToHome();
  }

  async newRefreshActiveBooking(pageNo?: number) {
    if (this.subBookingByPlayer) return;
    this.refresher = true;
    this.bookingByPlayerList = [];
    this.activeBookingForPlayerList = [];
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: false,
    });

    let _playerId;
    if (this.userType === 'player') {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _playerId = player.playerId;
      });
    }

    let _fromDate = moment().format('YYYY-MM-DD'); //moment(this.startDate).format("YYYY-MM-DD");
    this.activeDateSince = _fromDate;
    // let _toDate = moment(this.activeDate).endOf('month').format('YYYY-MM-DD');
    // if(this.prevPage('active')) {
    //   _fromDate = moment(this.activeDate).startOf('month').format('YYYY-MM-DD');
    //   _toDate = moment(this.activeDate).endOf('month').format('YYYY-MM-DD');
    // } else {
    //   _fromDate = moment().format('YYYY-MM-DD');
    //   _toDate = moment(this.activeDate).endOf('month').format('YYYY-MM-DD');
    // }
    let _toDate = moment(this.activeDate)
      .add(this.bookingNextMonth, 'month')
      .endOf('month')
      .format('YYYY-MM-DD');

    let _clubId = null;
    if (this.clubInfo && this.clubInfo.clubId) _clubId = this.clubInfo.clubId;
    let _statusType = 'A'; //(A)ctive, (I)nactive, (B)oth
    let _statusList: Array<string> = [];
    let _courseId = null;
    let _search = '';
    if (this.searchQuery && this.searchQuery.length > 0)
      _search = this.searchQuery.toLowerCase().trim();
    let _pageSize = 50;
    let _pageNo = null;
    let _descendingDate = false;
    if (pageNo) _pageNo = pageNo;
    this.subBookingByPlayer = this.flightService
      .searchBookingPlayer(
        _playerId,
        _clubId,
        _fromDate,
        _toDate,
        _statusType,
        _statusList,
        _courseId,
        _search,
        _pageSize,
        _pageNo,
        _descendingDate
      )
      .subscribe(
        (dataPlayerBookingList: PagedData<TeeTimeBooking>) => {
          this.activePlayerBookingList = dataPlayerBookingList;
          this.activeCurrentPage = dataPlayerBookingList.currentPage;
          this.activeTotalPages = dataPlayerBookingList.totalPages;
          this.activeTotalItems = dataPlayerBookingList.totalItems;
          this.activePageSize = dataPlayerBookingList.totalInPage;
          let activeBookingForPlayerList: Array<TeeTimeBooking> = dataPlayerBookingList.items;
          loader.dismiss().then(() => {
            if (activeBookingForPlayerList.length > 0) {
              this.activeBookingForPlayerList = activeBookingForPlayerList;

              let _pastBookings;
              this.activeBookingForPlayerList.sort((a, b) => {
                if (a.slotAssigned.teeOffDate == b.slotAssigned.teeOffDate) {
                  return a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime
                    ? 1
                    : a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime
                      ? -1
                      : 0;
                } else {
                  return a.slotAssigned.teeOffDate < b.slotAssigned.teeOffDate ? 1 : -1;
                }
              });
              let _today = moment().format('YYYY-MM-DD');

              // this.activeBookingForPlayerList = this.activeBookingForPlayerList
              //   .filter((t) => {
              //     return (
              //       moment(t.slotAssigned.teeOffDate, 'YYYY-MM-DD').format(
              //         'YYYY-MM-DD'
              //       ) <= _today
              //     );
              //   })
              //   .map((t) => {
              //     return t;
              //   });

              // this.activeBookingForPlayerList =
              //   this.activeBookingForPlayerList.filter((tb: TeeTimeBooking) => {
              //     let _hasPlayer = tb.bookingPlayers.filter((p) => {
              //       if (p.player)
              //         return p.player.id === _playerId && !p.playerRemoved;
              //     });
              //     if (_hasPlayer && _hasPlayer.length > 0) return true;
              //     else return false;
              //   });

              // _pastBookings.forEach((t)=>{

              // })
            }
            this.refresher = false;
          });
          if (this.subBookingByPlayer) {
            this.subBookingByPlayer.unsubscribe();
            this.subBookingByPlayer = null;
          }
        },
        error => {
          this.loadingCtrl.dismiss();
          this.refresher = false;
          if (this.subBookingByPlayer) {
            this.subBookingByPlayer.unsubscribe();
            this.subBookingByPlayer = null;
          }
        }
      );
  }

  isBookingConfirmed(bookingSlot: TeeTimeBooking) {
    // if (1) return false;
    if (!bookingSlot) return true;
    if (bookingSlot?.bookingConfirmationStatus === null) return true;
    if (bookingSlot?.bookingConfirmationStatus === undefined) return true;
    if (
      bookingSlot?.bookingConfirmationStatus === 'Pending' ||
      bookingSlot?.bookingConfirmationStatus === 'Rejected'
    )
      return false;
    return true;
  }

  initSwiper(type?: string) {
    const menuOpts = {
      slidesPerView: this.isMobileLayout() ? 2.3 : 5,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      on: {
        beforeInit: swiper => {
          swiper.classNames.push('swiper-container-custom');
        },
        slideChange: swiper => {
          if (swiper.isEnd) {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }
        },
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      },
    };
    if (this.swiperTabContainer && this.swiperTabContainer.nativeElement)
      this.swiperMenu = new Swiper(this.swiperTabContainer.nativeElement, menuOpts);
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }
}
